import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: {
        operator_Zain: 'Zain',
        operator_STC: 'STC',
        operator_Mobily: 'Mobily',
        operator_Salam: 'Salam',
        'Short Code is used by a Sender': 'Short Code is used by a Sender',
        shared: {
            providerAttachments: "Attachments",
            deactivatedSuccessfully: "Deactivated Successfully",
            activatedSuccessfully: "Activated Successfully",
            templateVariables: "Template Variables",
            preApprovedTemplate: "Pre-Approved Template",
            preApprovedTemplateDetails: "Pre-Approved Template Details",
            cstLicense: "CST License",
            commercialRegistration: "Commercial Registration",
            delegationLetter: "Delegation letter",
            nationalAddress: "National Address",
            zakatTaxCertificate: "Zakat / Tax Certificate",
            attachmentsRequired: "Please upload all required attachments before submitting.",
            invalidFileType: "Only PDF or DOCX files are allowed.",
            aiAttachmentReview: 'AI Attachment Review',
            fieldName: 'Field Name',
            providerInput: 'Provider Input',
            aiResult: 'AI Result',
            matched: 'Matched',
            notMatched: 'Not Matched',
            chamberStamp: 'Chamber of commerce stamp',
            delegationLetterStamp: 'Official entity letterhead',
            entityStamp: 'Entity stamp',
            senderNamesDetected: 'Sender Names Detected',
            notDetected: 'Not Detected',
            validationFailed: 'Validation Failed',
            aiVlidationFailed: 'AI Validation API Error',
            reasons: 'AI Validation Reasons',
            stampVerification: 'Stamp Verification',
            loadingAIReview: 'Loading AI Attachment Review...',
            loadingAIValidation: 'AI validation is in progress. Please wait..',
            aiUnavailableProceed: 'The service is currently unavailable, but you may proceed as usual',
            recheck: ' Recheck',
            recheckDone: 'AI Review Completed Successfully',
            mismatchFound: 'Mismatch found between entered data and uploaded file, Do you want to continue?',
            aiAttachmentnote: 'The field data and stamp shown here the AI have extracted them from the documents you uploaded. If there is an error, you can go back and correct the data.',
            invalidAttachmentNote: 'Some AI results may be missing or incorrect due to incorrect documents. For best accuracy, please upload the correct documents or skip this step.',
            invalidAttachmentNoteAdmin: 'Some AI results may be missing or incorrect due to incorrect documents.',
            note: 'Note:',
            verified: 'Verified',
            unverified: 'Unverified',
            entityInfo: 'Entity info',
            senderInfo: 'Sender Info',
            missing: "Missing",
            senderSuggestionTooltip: "Sender AI suggestion. Please select a Sender Type first",
            aiAttachmentnoteReview: 'The field data and stamp shown here have been extracted from the documents uploaded.',
            senderWarning: "Warning: it’s possible that the sender name may be considered suspicious",
            scamListSenderWarning: 'Warning: The sender name {names} is found in the scam list',
            senderNameByAI: "Sender name selected by AI",
            representativeInfo: 'Representative Info',
            senderNameLength: "Must be at least {min} characters",
            representativeNameTooltip: "The name must be at least three parts or more",
            senderNameSymbolsError: "Symbols can't be at the start",
            senderNameSymbolsError2: "Symbols can't be at the end",
            attachments: 'Attachments',
            cannotEditAContractStatusToDeleted: 'Can Not Edit a Contract Status To Be Deleted',
            deactivatedby: 'Deactivated by',
            reactivatedBy: 'Reactivated By',
            gracePeriod: 'Grace Period',
            attachmentName: 'Attachment Name',
            addedDate: 'Added Date',
            addedBy: 'Added By',
            enableToEdit: 'Enable to edit',
            disableToEdit: 'Disable to edit',
            editComplaintInputText: 'Are you sure you want to Edit Complaint?',
            rolesManagement: 'Roles Management',
            systemConfiguration: 'System Configuration',
            employeeStatistics: 'Employee Statistics',
            shortCodeLinking: 'Short Code Linking',
            tenant: 'Tenant',
            favorite: 'Favorite',
            unfavorite: 'Unfavorite',
            favoriteInputText: 'Are you sure you want to  favorite this client?',
            unfavoriteInputText: 'Are you sure you want to  unfavorite this client?',
            clientFavoriteSuccessfully: 'Client Favorite Successfully',
            clientUnfavoriteSuccessfully: 'Client Unfavorite Successfully',
            pendingForReview: 'Pending For Review',
            thisSenderOriginallyOnlyHasWarningSenderType: 'This Sender Originally Only Has Warning Sender Type.',
            renewalInfo: 'Renewal Info',
            sendersRenewal: 'Senders Renewal',
            renewContractRequest: 'Renew Contract Request',
            finalApprovedsuccessfully: 'Final Approved Successfully',
            finalApproveInputText: 'Are you sure you want to Final Approve the selected Senders?',
            finalApproveInput: 'Final Approve',
            review: 'Review',
            action: 'Action',
            deleteHistory: 'Are you sure you want to delete this history?',
            deleteHistorySuccessfully: 'Delete History Successfully',
            pendingPayment: 'Pending Payment',
            autoVerificationCompletedSuccessfully: 'Auto Verification Completed Successfully',
            representativeID: 'Representative ID',
            crExpiryDate: 'CR Expiry Date',
            addHistoryInputText: 'Are you sure you want to add this history?',
            addHistory: 'Add History',
            requestHistorySuccessfully: 'Request History Added Successfully.',
            historyDate: 'History Date',
            youMustSelectAtLeastOneRequestToChangeStatus: 'You must select at least one request to change status',
            manual: 'Manual',
            auto: 'Auto',
            iHaveTrademark: 'I Have a Trademark',
            domainName: 'Domain Name',
            trademarkName: 'Trademark Name',
            protectionDateFrom: 'Protection Date From',
            protectionDateTo: 'Protection Date To',
            trademarkRequired: 'Trademark Required',
            invalidDateRange: 'Invalid Date Range',
            domainNameRequiredFor: 'Domain Name Required For Short Sender Names',
            addingType: 'Adding Type',
            autoActivationNote: 'When Auto is selected, it automatically connects all short codes based on sender type and operator',
            paymentAutoDeductNote: 'The amount will be deducted directly from your credit limit upon approval',
            connectivityAdding: 'Connectivity Adding',
            reactivateInput: 'Reactivate',
            reactivateInputText: 'Are you sure you want to reactivate the selected Senders?',
            complaintID: 'Complaint ID',
            senderComplaintsList: 'Sender Complaints List',
            aPIUser330: '330API User',
            skipped: 'Skipped',
            forVariableValueUse: 'For varibale value use : #Var#',
            defaultTemplate: 'Dear customer /n Reminder for your appoiment (#var ) /n Thankyou,',
            TemplateInfo: 'Template Info',
            OneYear: 'One Year',
            OneMonth: 'One Month',
            TwoMonths: 'Two Months',
            ThreeMonths: 'Three Months',
            FourMonths: 'Four Months',
            FiveMonths: 'Five Months',
            SixMonths: 'Six Months',
            SevenMonths: 'Seven Months',
            EightMonths: 'Eight Months',
            NineMonths: 'Nine Months',
            TenMonths: 'Ten Months',
            ElevenMonths: 'Eleven Months',
            TwelveMonths: 'Twelve Months',
            variable: 'Variable',
            variables: 'Variables',
            nonVariable: 'Non Variable',
            normal: 'Normal',
            express: 'Express',
            templateValue: 'Template Content',
            previewContent: 'Preview Content',
            autoValidation: 'Auto Validation',
            channel: 'Channel',
            loading: 'Loading...',
            value: 'Value',
            processingDuration: 'Processing Duration',
            templateExpiry: 'Template Expiry',
            templateName: 'Template Name',
            templateDescription: 'Template Description',
            suggestedFreeContent: 'Suggested Free Content',
            suggestedFreeContentDescription: 'Select a free template matching your classification. Selecting a template disables custom content entry and skips AI validation.',
            selectClassificationForSuggestedContent: 'Select a Classification above to view the 3 suggested free templates.',
            noSuggestedTemplates: 'No suggested templates available for this classification.',
            selectSuggestedFreeTemplate: 'Please select a suggested free template',
            deselect: 'Deselect',
            selected: 'Selected',
            speedUpApproval: 'Speed up the template approval',
            licensesAndApproval: 'Licenses & Approval',
            pdfFilesOnly: 'Allowed file type: PDF only.',
            maxLicenseAttachments: 'Maximum 3 files allowed.',
            uploadLicensesAndApproval: 'Upload Licenses & Approval',
            smsTemplateRegulationsLink: 'SMS Template Regulations (PDF)',
            addVariable: 'Add Variable',
            deleteVariable: 'Delete Variable',
            variableExample: 'Variable Example',
            variableExamplesRequired: 'All variable example fields must have a value.',
            charactersRemaining: 'The character count excludes the variables',
            templateCharacterCount: 'Characters count: {count}',
            templateDescriptionMinLength: 'Template description must be at least 3 characters',
            templateDescriptionMaxLength: 'Template description must not exceed 160 characters',
            aiValidationRemarks: 'AI Validation Remarks',
            organizationNameSuffix: 'Organization name is automatically added and counted',
            addVariableNote:'You can add variable to the template content using the (+) button.',
            templateVariableBoundaryInvalid: 'Template must not start or end with a variable. Use the delete button to remove variables.',
            MessageTemplateDashboard: 'Template Management',
            templateStatus: 'Template Status',
            senderNameInformation: 'Sender Name Info',
            cstTemplateRegulations: 'CST SMS Template Regulations',
            senderNameFilter: 'Sender name',
            dataNotFound: 'Data not found',
            contractExpiryDate: 'Contract Expiry Date',
            tenantName: 'Platform',
            attachmentList: 'Attachments List',
            searchForRequest: "Search for request",
            ccv: "CCV",
            chargeBalanceInstruction: "You can charge your balance by transferring or depositing money (including VAT) to bank account {account}. After transfer, please share the receipt with Hawsabah support team.",
            senderNameAI: "Sender name selected by AI",
            crAutoVerificationSuccess: "CR Auto verification completed successfully",
            addAttachment: "Add Attachment",
            pleaseAttachAtLeast1DocumentWithCategoryDelegationLetter: 'Please attach at least 1 document with category Delegation Letter',
            pleaseattachAtLeast2DocumentsWithCategoryDelegationLetterAndCommercialDocument: 'Please attach at least 2 documents with category Delegation Letter and Commercial document',
            pleaseAttachaAtLeast2DocumentsWithCategoryDelegationLetterAndHRSDLicense: 'Please attach at least 2 documents with category Delegation Letter and HRSD License',
            saudiDomainCertificateRequired: 'Please attach Saudi domain registration, it is required for short sender names.',
            trademarkCertificateRequired: 'Please attach Trademark registration, it is required for 3-letter sender names.',
            forAdditionalDocumentSelectTheAppropriateCategory: 'For additional document select the appropriate category',
            canNotAddArequestWithoutADelegationLetter: 'Can Not Add A Request Without A Delegation Letter Attachment',
            canNotAddArequestWithoutCommercialRegistrationAttach: 'Can Not Add A Request Without Commercial Registration Attachment',
            canNotAddArequestWithoutHRSDLicenseAttach: 'Can Not Add A Request Without HRSD License Attachment',
            noAttachments: 'No Attachments',
            attachment: 'Attachment',
            addCategory: 'Add Category',
            other: 'Other',
            requiredDocGovernment: 'Required Doc: Delegation Letter.',
            requiredDocPrivate: 'Required Doc: Delegation Letter and Commercial Registration.',
            requiredDocCharity: 'Required Doc: Delegation Letter and HRSD License.',
            additionalFilesSelectCategory: 'For additional files, select the correct category',
            maxFileSize3MB: 'The maximum file size is: 3MB',
            providerStatus: 'Provider Status',
            expireDate: 'Expiry Date',
            integrationBaseURL: 'Integration Base URL',
            integrationApiKey: 'Integration API Key',
            isIntegrated: 'Is Integrated',
            switchAdminToSuper: 'Swtich Admin User To Super Admin User',
            switchAdminToSuperText: 'Are you Sure to Switch Admin User To Super Admin User ?',
            sorryUnrecognizedRequestType: 'Sorry Unrecognized Request Type',
            RequestType: 'Request Type :',
            operator: 'Operator :',
            Operator: 'Operator',
            senderEditedSuccessfully: 'Sender Edited Successfully',
            edit: 'Edit',
            editSenderStatusInputText: 'Are you sure you want edit sender status?',
            senderId: 'Sender Id',
            approved: 'Approved',
            rejected: 'Rejected',
            deactivated: 'Deactivated',
            expired: 'Expired',
            paid: 'Paid',
            RejectionReason: 'Rejection Reason',
            canceled: 'Canceled',
            senderExpiryDate: 'Sender Expiry Date',
            customDayMustBeLargerThanTheEnteredValue: 'Custom Day Must Be Larger Than The Entered Value',
            customDaySearchMustBeUsingANumber: 'Custom Day Search Must Be Using a Number.',
            scamAddSuccessfully: 'Scam Added Successfuly',
            deleteScamSuccessfully: 'Scam Deleted Successfuly',
            editScamSuccessfully: 'Scam Edited Successfuly',
            ScamManagement: "Scam Monitoring List",
            theMaximumSizeForTheAttachmentIs3Megabytes: 'The maximum size for the attachment is 3 megabytes',
            fileSizeExceedsTheLimit: 'File Size Exceeds The Limit.',
            days: ' Days',
            daysAndMore: ' Days and more',
            from: 'From : ',
            to: 'To :  ',
            pendingActivationRequests: 'Pending Activation Requests',
            operatorStatus: 'Operator Status',
            sorryUnrecognizedRequestStatus: 'Sorry! Unrecognized Request Status',
            requestsAlerts: 'Requests Alerts',
            allRequests: 'All Requests',
            allsenders: 'All senders',
            allActiveSenders: 'All Active Senders',
            PendingActivation: 'Pending Activation',
            PendingPaymentRequests: 'Pending Payment Requests',
            requestsAlertsPendingActivation: 'Requests Alerts - Pending Activation',
            requestsAlertsPendingPaymentRequests: 'Requests Alerts - Pending Payment Requests',
            requestsAlertsPendingApprovalRequests: 'Requests Alerts - Pending Approval Requests',
            custom: 'Custom',
            more: 'More',
            twenyfourDays: '24 days',
            tenDays: '10 days',
            twoDays: '2 days',
            PendingApprovalRequests: 'Pending Approval Requests',
            alerts: 'Alerts',
            paidRequests: 'Paid Requests',
            activatedRequests: 'Activated Requests',
            pendingApproval: 'Pending Approval',
            rejectedRequests: 'Rejected Requests',
            charities: 'Charities',
            governmental: 'Governmental',
            all: 'All',
            approvedRequests: 'Approved Requests',
            date: 'Date',
            entityType: 'Entity Type',
            client: 'Client',
            sender: 'Sender',
            senders: 'Senders',
            shortCodeEditDisabled: 'Short Code Type can not be edited because it is already connected to a sender',
            renewSender: 'Renew Sender',
            sadadPaymentDisclaimer: 'The invoice will be issued for ',
            sadadPaymentDisclaimerArabic: ' ستصدر الفاتورة لمزود الخدمة ',
            senderCriticality: 'Sender Criticality',
            notCritical: 'Not Critical',
            critical: 'Critical',
            criticalSender: 'Critical Sender',
            publicPaymentDisclaimer: 'لا تتحمل شركة حوسبة التقنية لتقنية المعلومات أي مسؤولية ناتجة عن بيانات العميل في النظام، بما في ذلك، على سبيل المثال لا الحصر، ما يتعلق بدقة أو صحة أي بيانات العميل. وفي جميع الأحوال، لا تتحمل شركة حوسبة التقنية لتقنية المعلومات أي مسؤولية، تجاه أي زوار أو أطراف ثالثة فيما يتعلق بالبيانات المدخلة من قبلهم.',
            sadadNumberCreatedSuccessfully: 'Sadad Number Created Successfully',
            sadadNumber: 'Sadad Number',
            getSadadNumber: 'Get Sadad Number',
            status: 'Status',
            lockProviderInput: 'Provider status change',
            lockProviderInputText: 'Are you sure you want to lock the selected provider?',
            unlockProviderInputText: 'Are you sure you want to unlock the selected provider?',
            editProviderStatusSuccessfully: 'Provider status edited successfully',
            editProviderShortcodeLinkSuccessfully: 'Edit Provider Shortcode Link Successfully',
            extend: 'Extend',
            extendRequestTypeInput: 'Extend Request',
            extendInputText: 'Are you sure you want to extend duration for this senders?',
            showExtendRequest: 'Show Extend Request',
            extendRequest: 'Extend Request',
            extendDurationRequests: 'Extend Duration Requests',
            extendRequestedSuccessfully: 'Extend Requested Successfully',
            extendRequestedUpdatedSuccessfully: 'Extend Requested Updated Successfully',
            senderConnectivity: 'Sender Connectivity',
            company: 'Company',
            zain: 'Zain',
            mobily: 'Mobily',
            sTC: 'STC',
            salam: 'Salam',
            exportToExcel: 'Export To Excel',
            selectCompany: 'Select Company',
            balanceInvoice: 'Balance Invoice',
            invoiceCreatedSuccessfully: 'Invoice Created Successfully',
            createInvoiceInputText: 'Do you want to issue a balance invoice for this transaction?',
            activation: 'Activation',
            isActive: 'Is Active',
            activationDate: 'Activation Date',
            activationInformation: 'Activation Information',
            trackRequest: 'Track Request',
            rejectionReasonOrComment: 'Rejection Reason/Comment',
            comment: 'Comment',
            commentMinLength: 'Comment must be at least 3 characters',
            mobilyActivationDate: 'Mobily Activation Date',
            salamActivationDate: 'Salam Activation Date',
            lebaraActivationDate: 'Lebara Activation Date',
            sTCActivationDate: 'STC Activation Date',
            zainActivationDate: 'Zain Activation Date',
            requestId: 'Request Id',
            connectivityActivationReport: 'Connectivity Activation Report',
            connectivityStatus: 'Connectivity Status',
            SenderRequestActionsInput: 'Request Actions',
            showSenderRequestActions: 'Show Sender Request Actions',
            showSenderActivityHistory: 'Sender Activity History',
            senderActivityHistory: 'Sender Activity History',
            showRequestActions: 'Show Request Actions',
            numberOfActions: 'Number Of Actions',
            senderRequestPaymentTransactions: 'Sender Request Payment Transactions',
            paymentStatus: 'Payment Status',
            senderRequestApprovalHistory: 'Sender Request Approval History',
            transactionReference: 'Transaction Reference',
            checkOutId: 'Checkout Id',
            creditLimitPayment: 'CreditLimit Payment',
            isMada: 'Is Mada',
            userId: 'User Id',
            senderRequestSupport: 'Sender Request Support',
            requestType: 'Request Type',
            changedProperty: 'Changed Property',
            approvalHistory: 'Approval History',
            paymentTransactions: 'Payment Transactions',
            slaNote1: '* Requests of three characters or less require more time, up to 5 working days',
            slaNote2:
                '** If the operator or system developer requires more time, then Hawsaba will notify the client - within 2 working days- with updated response time.',
            problemsWithASpecificSIDOrLinkWithOperators: 'problems with a specific SID or link with operators',
            workingDays2: '2 working days**',
            technicalSupport: 'Technical support',
            workingDay2: '2 working days*',
            processingARequestWithAcceptanceOrRejectionBasedOnTheRegistrationCriteria:
                'Processing a request with acceptance or rejection based on the registration criteria',
            sIDRequest: 'SID Request',
            three: '3',
            two: '2',
            one: '1',
            workingDay1: '1 working day',
            inquiriesAboutTheSystemOrAboutAdmissionCriteria: 'Inquiries about the system or about admission criteria',
            inquiries: 'Inquiries',
            description: 'Description',
            responseTime: 'Response Time',
            sla: 'SLA',
            paymentDate: 'Payment Date',
            expiryDate: 'Expiry Date',
            creditCardVisaMastercard: 'Credit Card (Visa,Mastercard)',
            debitCardMada: 'Debit Card(Mada)',
            createPaymentLinkVisaMastercard: 'Create Payment Link (Visa,Mastercard)',
            createPaymentLinkMada: 'Create Payment Link (Mada)',
            details: 'Details',
            provider: 'Provider',
            convertToAdded: 'Convert To Added',
            markAsAddedInputText: 'Are you sure you want to convert status of the selected Connectivity to added?',
            convertToDeleted: 'Convert To Deleted',
            markAsDeletedInputText: 'Are you sure you want to convert status of the selected Connectivity to Deleted?',
            resendToOperator: 'Resend To Operator',
            resendToOperatorInputText: 'Are you sure you want to Resend the selected Connectivity to Operator?',
            convert: 'Convert',
            resend: 'Resend',
            updateRequestDataInputText: 'Are you sure you want to Update Sender Request Data?',
            updateDataRequests: 'Update Requests',
            updateRequestData: 'Update Request Data',
            view: 'View',
            thisFieldIsRequired: 'This field is required.',
            noDataFound: 'No Data Found.',
            updateRequestCreatedSuccessfully: 'Update request created successfully',
            updateContractRequest: 'Edit Contract Request',
            updateMessageTemplateRequest: 'Edit Message Template Request',
            Paid: 'Paid',
            myProfileInfo: 'My Profile Information',
            myProfile: 'My Profile',
            createddate: 'Created Date',
            InvalidMobileNumber: 'Invalid Mobile Number',
            InvalidEmail: 'Must be valid email',
            Id10digits: 'Must be 10 digits',
            NumberStart5: 'The number must start with 5',
            IdStart1: 'The ID must start with 1',
            InvalidIdNumber: 'Invalid Id Number',
            invoiceUnderProcessing: 'Invoice Under Processing',
            invoiceNumber: 'Invoice Number',
            FaildToEnterPaymentPage: 'Not all senders names are ready to pay',
            organizationName: 'Organization Name',
            clientInformation: 'Client Information',
            senderInformation: 'Sender Information',
            templateInformation: 'Template Information',
            referenceNumber: 'Reference Number',
            ToAddTypeAdvertisementSendernameShouldBeLessThanOrEqual8: 'To Add Type Advertisement Sender name Should Be Less Than Or Equal 8',
            ToAddTypeServiceWithCustomerTypeInternationalSendernameShouldBeLessThanOrEqual8: 'To Add Type Service With Customer Type International Sender name Should Be Less Than Or Equal 9',
            copyLink: 'Copy Link',
            createPaymentLink: 'Create Payment Link',
            buyerName: 'Buyer Name',
            buyerCountry: 'Buyer Country',
            buyerCity: 'Buyer City',
            buyerDistrict: 'Buyer District',
            buyerStreetName: 'Buyer Street Name',
            buyerBuildingNumber: 'Buyer Building Number',
            buyerVatNumber: 'Buyer VatNumber',
            buyerPostalCode: 'Buyer PostalCode',
            buyerAdditionalNumber: 'Buyer Additional Number',
            buyerOtherIdentifier: 'Buyer Other Identifier',
            editProviderFinanceInfo: 'Edit Provider Finance Information',
            providersFinance: 'Providers Finance Info',
            BalanceInvoice: 'Balance Invoices',
            balance: 'Balance',
            Go: 'Go',
            CreditLimitTransaction: 'Credit Limit Transaction',
            sendersName: 'Sender Name',
            paymentdate: 'Payment Date',
            creditLimitAmount: 'Credit Limit Amount',
            fellInfo: 'can you fill the following information about the provider',
            reLogin: 'Re-Login',
            amount: 'Amount',
            Invoices: 'Invoices',
            InvoicesNumber: 'Invoices Number',
            invoicesList: 'Invoices List',
            ConverttoAdded: 'Convert to Added',
            ConverttoDeleted: 'Convert to Deleted',
            ConvertStatus: 'Convert Status',
            lastModifiedDate: 'Last Modified Date',
            addSuccessfully: 'Added Successfully',
            deleteSuccessfully: 'Deleted Successfully',
            changeSenderTypeRequests: 'Change Sender Type Requests',
            renewRequest: 'Renew Request',
            renewRequestTypeInput: 'Renew Request',
            renewInputText: 'Are you sure you want to Renew this Sender Request?',
            renewRequestSuccessfully: 'Renewed Successfully',
            Search: 'Search',
            CITCKeywordsList: 'Keywords List',
            addCITCKeywords: 'Add  Keyword',
            editKeyword: 'Edit Keyword',
            addNewCITCKeywords: 'Add New Keyword',
            CITCKeywords: 'Keywords',
            preApprovedTemplates: 'Pre-Approved Templates',
            addPreApprovedTemplate: 'Add New Template',
            editPreApprovedTemplate: 'Edit Pre-Approved Template',
            addPreApprovedTemplateConfirm: 'Are you sure you want to add this pre-approved template?',
            editPreApprovedTemplateConfirm: 'Are you sure you want to update this pre-approved template?',
            templateId: 'Template ID',
            contentPreview: 'Content Preview',
            templateContent: 'Template Content',
            editSuccessfully: 'Updated Successfully',
            saveFailed: 'Save failed',
            loadFailed: 'Failed to load data',
            regulationsMenu: 'AI regulations',
            regulationsListTitle: 'AI regulations',
            addNewRegulation: 'Add regulation',
            editRegulation: 'Edit regulation',
            regulationFilterCategory: 'Filter by category',
            regulationAllCategories: 'All categories',
            regulationCategory: 'Category',
            regulationStatus: 'Status',
            regulationPolicies: 'Policies text',
            regulationAiPrompt: 'AI prompt',
            regulationCategorySmsTemplate: 'SMS template',
            regulationCategorySenderName: 'Sender name',
            regulationStatusDraft: 'Draft',
            regulationStatusActive: 'Active',
            regulationPoliciesPlaceholder: 'Enter the regulatory policy text used to generate the AI check prompt.',
            regulationPoliciesRequired: 'Policies text is required.',
            regulationCannotEditActive: 'Active regulations cannot be edited. Create a draft or deactivate via a new active version first.',
            regulationLoadFailed: 'Failed to load regulations.',
            regulationDeleteFailed: 'Failed to delete regulation.',
            regulationSaveFailed: 'Failed to save regulation.',
            noActiveRegulationFoundForThisCategory: 'No active regulation found for this category',
            regulationSaved: 'Saved successfully.',
            AttachmentCategoryList: 'Attachments Categories List',
            AttachCategoryCharValidation: 'Category Name must be between 5-128 character',
            addAttachmentCategory: 'Add  Category',
            editCategory: 'Edit Category',
            addNewAttachmentCategory: 'Add New Category',
            AttachmentCategory: ' Attachment Category',
            AttachmentCategoryName: ' Category Name',
            GotoDashboard: 'Go to Dashboard',
            ConvertedSuccessfully: 'Converted Successfully',
            SenderConnectivitySupport: 'Sender Connectivity Support',
            SupportPaymentTransaction: 'Payment Transaction',
            paymentReference: 'Payment Reference',
            shortcode: 'Short Code',
            senderName: 'Sender Name',
            senderNameShouldNotBeOneOfTheKeywords: 'Sender Name Could Not Be One Of The Keywords',
            senderConectivityDetail: 'Sender Connectivity Detail',
            licenseNumber: 'HRSD License Number',
            internationalCommercialRegistrationNumber: 'International Commercial Registration Number',
            commercialRegistrationNumber: 'Commercial Registration Number',
            AddProviderRequest: 'Add Provider Request',
            unLock: 'Unlock',
            users: 'Users',
            lock: 'Lock',
            providerRequests: 'Provider Requests',
            providerRequestInfo: 'Provider Request Info',
            apply: 'Apply',
            exporttoexcel: 'Export To Excel',
            rejectionResson: 'Rejection Reason',
            ApprovedRequestSuccessfully: 'Provider Request Has been Approved successfully',
            RejectedRequestSuccessfully: 'Provider Request Has been Rejected successfully',
            emailVerification: 'Email Verification',
            otpSentToEmail: 'A verification code has been sent to your email. Please input the code to submit your request.',
            enterVerificationCode: 'Enter verification code',
            otpExpiredMessage: 'The verification code has expired. Please request a new code.',
            otpResendCountDown: 'Resend available in',
            verificationSuccessful: 'Verification successful. Your request has been submitted.',
            invalidOTPCode: 'Invalid verification code. Please try again.',
            otpResentSuccessfully: 'Verification code has been resent to your email.',
            verify: 'Verify',
            errorOccurred: 'An error occurred. Please try again.',
            forbiddenCharsError: 'The characters <, > and -- are not allowed.',
            email: 'Email',
            addConectivitySuccessfully: 'Add Connectivity is successfully',
            resentSuccessfully: 'Resent Successfully',
            resendtooperator: 'Resend To Operator',
            Invalidresendtooperator: 'Invalid selection, You can only resend short codes with "Added" status.',
            Invalidresendtooperatordeletion: 'Invalid selection, You can only resend short codes with "Deleted" status.',
            InvalidresendSelection: 'Invalid selection. You can only resend Shortcodes with the same status (Added or Deleted)',
            AddUsersuccessfully: 'Add User Successfully',
            domainHelperTextPrefix: 'Looking for a Saudi domain (.sa)? Check the list of licensed registrars:',
            domainHelperTextLink: 'https://nic.sa/registrars/',
            lockInput: 'User status change',
            lockInputText: 'Are you sure you want to lock the selected user?',
            unlockInputText: 'Are you sure you want to unlock the selected user?',
            addNewConectivity: 'Add New Connectivity',
            addRequest: 'Add Request',
            addResponse: 'Add Response',
            deleteRequest: 'Delete Request',
            deleteResponse: 'Delete Response',
            Conectivitylog: 'Connectivity log',
            selectAll: 'Select All',
            conectivityStatus: 'Connectivity Status',
            deleted: 'Deleted',
            pendingDeletion: 'Pending Deletion',
            confirm: 'Confirm',
            added: 'Added',
            pendingAddition: 'Pending Addition',
            deleteConectivitySuccessfully: 'Delete Connectivity is successfully',
            senderType: 'Sender Type',
            Expired: 'Expired',
            Deleted: 'Deleted',
            Deactivated: 'Deactivated',
            Approved: 'Approved',
            Rejected: 'Rejected',
            PendingApproval: 'Pending Approval',
            senderStatus: 'Sender Status',
            Report: 'Report',
            Reports: 'Reports',
            ReportsOverview: 'Overview Report',
            customerType: 'Customer Type',
            approveDateFrom: 'Approve Date From',
            createdDate: 'Created Date',
            approveDateTo: 'Approve Date To',
            createdDateTo: 'Created Date To',
            createdDateFrom: 'Created Date From',
            customerId: 'Customer Id',
            MSISDN: 'MSISDN (SAN)',
            unifiedNumber: 'Unified Number',
            government: 'Government',
            charity: 'Charity',
            errorSenderNameDuplicate: 'This sender name already exists in your list',
            SenderNameExist: 'Sender name already exist',
            selectSenderType: 'Select sender type first',
            private: 'Private',
            international: 'International',
            advertisement: 'Advertisement',
            service: 'Service',
            awareness: 'Awareness',
            warning: 'Warning',
            errorSystem: 'An error occurred in the system',
            errorSenderNameEnd: 'The Sender name must not end in -AD or -I',
            PaymentSuccess: 'Payment Success !',
            editSenderSuccessfully: 'Edit Sender Is Successfully',
            senderNameShouldbenumbersandChar: 'Sender Name Should Contains Numbers & Characters',
            senderNameShouldbe2OrmoreChar: 'Minimum Length of the sender is 2 characters',
            PaymentFaild: 'Payment Faild !',
            PaymentFaildMsg: 'If the amount was deducted, please contact the admin',
            errorUserCertificate: 'Not same user, Please Re-Login the current user',
            userCertificate: 'User Certificate',
            language: 'العربية',
            dashboard: 'Sender Request Dashboard',
            providers: 'Providers',
            operators: 'Operators',
            selectStatus: 'Select Status',
            shorts: 'Short Codes',
            userManagement: 'User Management',
            DashboardApprovedRequests: 'Chart Dashboard',
            rowsPerPage: 'Rows Per Page',
            newUser: 'New user',
            editUser: 'Edit user',
            name: 'Name',
            userName: 'User Name',
            userEmail: 'User Email',
            phoneNumber: 'Phone Number',
            phoneNumberAdmin: 'Provider Admin Phone Number',
            userNameAdmin: 'Provider Admin User Name',
            country: 'Country',
            city: 'City',
            district: 'District',
            streetName: 'Street Name',
            buildingNumber: 'Building Number',
            postalCode: 'Postal Code',
            vatNumber: 'VAT Number',
            additionalNumber: 'Additional Number',
            otherIdentifier: 'Other ID',
            userEmailAdmin: 'Provider Admin User Email',
            type: 'Type',
            selectOperator: 'Select Operator',
            selectProvider: 'Select Provider',
            requestStatus: 'Request Status',
            selectType: 'Select Type',
            save: 'Save',
            userInfo: 'User information',
            providerName: 'Provider Name',
            providerCode: 'Provider Code',
            operatorName: 'Operator Name',
            editInfo: 'Edit Info',
            actions: 'Actions',
            deleteInput: 'Delete',
            deleteMessageTemplateInputText: 'Are you sure you want to delete the selected message template?',
            deactivateMessageTemplateInputText: 'Are you sure you want to deactivate the selected message template?',
            userRole: 'User Role',
            deleteInputText: 'Are you sure you want to delete the selected item?',
            resendPassword: 'Resend Password',
            resendPasswordText: 'Are you sure you want to resend the password of the selected user?',
            deactivateInput: 'Deactivate',
            approveInput: 'Approve',
            resendInput: 'Resend',
            cancel: 'Cancel',
            delete: 'Delete',
            addProvider: 'Add Provider',
            editProvider: 'Edit Provider',
            providerUpdateinfo: 'Update Provider Info',
            add: 'Add',
            clientName: 'Client Name',
            crNumber: 'CR Number',
            budgetNumber: 'Budget Number',
            accreditationNumber: 'CST License Number',
            taxNumber: 'Tax Registration Number',
            hasInternational: 'Request International Sender',
            representativeName: 'Representative Name',
            enterpriseUnifiedNumber: 'Enterprise Unified Number',
            startDate: 'Start date',
            durationYear: 'Duration ( Year)',
            representativeEmail: 'Representative Email',
            attachDelegationLetter: 'Attach Delegation Letter',
            attachContract: 'Attach Contract',
            delegationletter: 'Delegation Letter',
            attacDocument: 'Attach Document',
            attachRegistrationDocument: 'Attach Registration Document',
            attachUnifiedNumberDocument: 'Attach Unified Number Document',
            attachbudgetNumberDocument: 'Attach Budget Number Document',
            attachlicenseNumberDocument: 'Attach HRSD License Number Document',
            attachinternationalCommercialRegistrationNumberDocument: 'Attach International Commercial Registration Number Document',
            attachcommercialRegistrationNumberDocument: 'Attach Commercial Registration Number Document',
            additionalAttachments: 'Additional Attachments',
            AlreadyActivated: 'Are the sender name and the shortcodes already activated in the operators database before launching this platform?',
            AlreadyActivatedAR: 'هل اسم المرسل و الرموز القصيرة مفعلة في أنظمة قواعد بيانات المشغلين قبل إطلاق هذه المنصة الإلكترونية؟',
            isAlreadyExist: 'I attest that the sender has been already activated before launching the system. As a result the sender will not be sent to operators for activation',
            optional: '(Optional)',
            attach: 'Attach',
            sendersList: 'Sender Type',
            NotAllSenderApprovedOrPaid: 'Not All Selected Senders Approved Or Paid',
            sureAddConnectivity: 'Are you sure to add this Connectivity?',
            deactivateInputText: 'Are you sure you want to deactivate the selected senders? ',
            deactivateInputTextSingle: 'Are you sure you want to deactivate this sender? ',
            deletesenderInputText: 'Are you sure you want to Delete the selected Senders?',
            resendInputText: 'Are you sure you want to Resend the selected Senders?',
            resendContractInputText: 'Are you sure you want to Resend the selected Contract Requests?',
            resendMessageTemplateInputText: 'Are you sure you want to Resend the selected Message Template Requests?',
            approveInputText: 'Are you sure you want to Approve the selected Senders?',
            approveMessageInputText: 'Are you sure you want to approve the selected request?',
            approveContractInputText: 'Are you sure you want to approve the selected contract?',
            approveProviderRequestInputText: 'Are you sure you want to Approve this Request?',
            approveProviderRequestsBulk: 'Are you sure you want to Approve the selected provider requests?',
            rejectProviderRequestInputText: 'Are you sure you want to Reject this request?',
            rejectProviderRequestsBulk: 'Are you sure you want to Reject the selected provider requests?',
            editProviderInputText: 'Are you sure you want to Edit Provider?',
            updateProviderInputText: 'Are you sure you want to update provider info?',
            editKeywordInputText: 'Are you sure you want to Edit Keyword?',
            addKeywordInputText: 'Are you sure you want to Add Keyword?',
            editCategoryInputText: 'Are you sure you want to Edit Category?',
            addCategoryInputText: 'Are you sure you want to Add Category?',
            editUserInputText: 'Are you sure you want to Edit User?',
            addUserInputText: 'Are you sure you want to Add User?',
            confirmRoleChange: 'Confirm Role Change',
            cstRoleChangeText: 'Are you sure you want to switch {fromRole} Role to {toRole}?',
            CSTAdmin: 'CST Admin',
            CSTUser: 'CST User',
            addInput: 'Add',
            addShortCodeInputText: 'Are you sure you want to Add Short Code?',
            editShortCodeInputText: 'Are you sure you want to Edit Short Code?',
            addsubmitRequestInputText: 'Are you sure you want to Add Request?',
            addsubmitContractRequestInputText: 'Are you sure you want to Add Contract Request?',
            updateContractRequestInputText: 'Are you sure you want to edit Contract Request?',
            updateMessageTemplateRequestInputText: 'Are you sure you want to edit Message Template Request?',
            addsubmitRenewContractRequestInputText: 'Are you sure you want to renew Contract Request?',
            editSenderInputText: 'Are you sure you want to Edit Sender ?',
            editInput: 'Edit',
            updateInput: 'Update',
            reset: 'Reset',
            next: 'Next',
            back: 'Back',
            stcShortCodes: 'STC ShortCodes',
            mobileAccounts: 'Mobile Accounts',
            zainShortCodes: 'Zain ShortCodes',
            salamShortCodes: 'Salam ShortCodes',
            addToList: 'Add to list',
            zainSC: 'Zain SC',
            mobilySC: 'Mobily SC',
            stcSC: 'STC SC',
            salamSC: 'Salam SC',
            apEmail: 'AP Email',
            sendersShortCodesList: 'Senders/ShortCodes List',
            duration: 'Duration',
            senderValidityPeriodExceeds5Years: 'The sender validity period cannot exceed 5 years',
            year: 'Year',
            submit: 'Submit',
            requestSubmittedSuccessfully: 'Request submitted successfully',
            newRequest: 'New request',
            requestsListPage: 'Requests list page',
            editRequest: 'Edit Request',
            changeSenderTypeInput: 'Change Sender Type',
            changeSenderTypeInputText: 'Are you sure you want to Change Sender Type?',
            changeSenderType: 'Change Sender Type',
            request: 'Request',
            actionHere: 'Action here',
            payment: 'Payment',
            cardNumber: 'Card number',
            exDate: 'Ex. Date',
            nameCard: 'Name on the card',
            orderSummary: 'Order Summary',
            CreditLimit: 'Credit Limit',
            CreditCard: 'Credit Card',
            PaymentOptions: 'Payment Options',
            paidSuccessfully: 'Paid Successfully',
            subtotal: 'Subtotal',
            total: 'Total',
            paymentInformation: 'Payment information',
            payNaw: 'Pay Now',
            payLater: 'Pay Later',
            renewalPaymentBack: 'Back',
            senderRenewalRequestAddedSuccessfully: 'Sender renewal request added successfully',
            senderRenewalRequestCreatedPendingPayment: 'Sender renewal request created successfully. Status: Pending payment. Please complete payment.',
            senderRenewalRequestPaymentCompletedStatusUpdated: 'Payment completed successfully. Sender renewal request status updated to Paid.',
            senderRenewalRequestPaymentFailedStillPending: 'Payment failed. Renewal request created. Proceed to Extend Duration Requests to complete payment',
            privacy: 'Privacy',
            termsOfUse: 'Terms of use',
            copyRight: 'All rights is reserved for T2 © MSG Stack',
            deleteShortSuccessfully: 'Delete Short Code is successfully',
            addShortSuccessfully: 'Add Short Code is successfully',
            updateShortSuccessfully: 'Update Short Code is successfully',
            addProviderSuccessfully: 'Add Provider is successfully',
            editProviderSuccessfully: 'Edit Provider is successfully',
            updatedProviderSuccessfully: 'Updated Provider successfully',
            Ok: 'Ok',
            noSenderNames: 'No Sender Names',
            select: 'Select',
            noData: 'No Data',
            noDataAvailable: 'No data available',
            logOut: 'Logout',
            logOutText: 'Are you sure you want to Logout?',
            yes: 'Yes',
            no: 'No',
            rejectionReason: 'Rejection Reason',
            paymentDateFrom: 'Payment Date From',
            paymentDateTo: 'Payment Date To',
            clientInfo: 'Client Info',
            contractInfo: 'Contract Info',
            reviewRequest: 'Review Request',
            connectingSenderName: 'Connecting Sender Name',
            connectingRequestDashboard: 'Contract Request Dashboard',
            check: 'check',
            representativeIDNumber: 'Representative Id Number',
            verificationType: 'Verification Type',
            automatic: 'Automatic Verification',
            suggestionsAndFeedback: 'Suggestions & Feedback',
            suggestionsAndSystemEnhancement: 'Suggestions & System Enhancements',
            serviceName: 'Service Name',
            title: 'Tilte',
            suggestionsOrSystemEnhancement: 'Suggestions or System Enhancements',
            addSuggestionsAndSystemEnhancement: 'Add Suggestions & System Enhancements',
            selectService: 'Select Service',
            addSuggestionsAndSystemEnhancementInputText: 'Are you sure you want to Submit your Suggestions or System Enhancement?',
            ratingResults: 'Rating Results',
            surveymanagement: 'Survey management',
            addSuggestionSuccess: "Thank you! Your suggestion has been submitted successfully.",
            suggestionTitle: 'Suggestion Title',
            ratingService: 'How would you rate the service quality on a scale of 1 to 5?',
            ratingDate: 'Rating Date',
            commant: 'Write your commant',
            reasonRequired: 'A reason is required for low ratings',
            ratingScale: 'Rating Scale',
            senderNameRegistration: 'Sender Name Registration',
            contractRequest: 'Contract Request',
            connectivityShortcode: 'Connectivity Shortcode',
            allEvaluation: 'All Evaluation',
            senderRegistrationEvaluation: 'Sender Registration Evaluation',
            contractEvaluation: 'Contract Evaluation',
            connectivityEvaluation: 'Connectivity Evaluation',
            ratingSuccess: 'Thank you! Your Service Rating has been sent successfully.',
            dateFrom: 'Date From',
            dateTo: 'Date To',
            commercialRegistrationManager: 'Commercial Registration Manager',
            representativePhoneNumber: 'Representative Phone Number',
            managerID: 'Manager ID',
            ensureClientName: '*Please ensure the client name is correct',
            notificationEmail: 'The notification will be sent to this email',
            notificationPhone: 'The notification will be sent to this phone number',
            validationType: 'Validation Type',
            suggestedSenderNames: 'Suggested Sender Names',
            permissionManagement: 'Permission Management',
            permissionManagementSave: 'Are you sure you want to save this change?',
            aiValidation: 'AI Validation',
            classification: 'Classification',
            Advertising: 'Advertising',
            Service: 'Service',
            Warning: 'Warning',
            Verification: 'Verification',
            Awareness: 'Awareness',
            checkTemplate: "Check Template By Ai",
            templateValid: "Template Validated By AI",
            templateInvalid: "Template is invalid. Please fix the issues.",
            aiCheckFailed: "AI review found validation errors. Please review the details below.",
        },
        labels: {
            budgetNumber: 'Budget Number',
            licenseNumber: 'License Number',
            commercialRegistrationNumber: 'Commercial Registration Number',
            unifiedEnterpriseNumber: 'Unified Enterprise Number',
            clientName: 'Client Name',
            expiryDate: 'Expiry Date',
            representativeName: 'Representative Name',
            representativePhone: 'Representative Phone',
            representativeEmail: 'Representative Email',
            representativeId: 'Representative ID',
        },
        errors: {
            validationFailed: 'Validation failed',
            CRNameMismatch: 'Sender Name does not match the trade name from the Commercial Registration document.',
            HRSDNameMismatch: 'Sender Name does not match the trade name from the HRSD document.',
            AuthorizationNameMismatch: 'Sender Name does not match the trade name from the Delegation Letter.',
            MissingBrandName: 'Brand Name could not be extracted from the trademark registration.',
            IPCOwnerNameMismatch: 'The owner of the Brand Name in the Trademark Registration does not match the entity name in the Commercial Registration Certificate.',
            MissingOrInvalidIPCDocumentForDomainMatch: 'Sender Name is shorter than 4 characters and there is no Trademark registration to verify it against the Saudi domain registration.',
            VerifyBrandOwnershipViaIPC: 'Sender Name does not match the document name. Please upload a valid Trademark Registration for further validation.',
            VerifyDomainCertificate: 'Sender Name does not match the Delegation Letter and is shorter than 4 letters. Please upload a valid Saudi domain registration for further validation.',
            DomainAndSenderDoNotMatchIPBrand: 'Sender Name does not match both the Saudi domain registration and the brand name.',
            BrandNameMismatch: 'Sender Name does not match the Brand name from the Trademark Registration.',
            InvalidSenderType: "Invalid sender type. Must be 'White List' or 'Advertising'.",
            InvalidFileType: 'Invalid file type. Allowed types are PDF and images.',
            InvalidEntityType: 'Invalid entity type. Allowed types are Government, Private, or Charity.',
            InternalProcessingFailed: 'An internal error occurred during processing.',
            savingFailed: 'Error saving uploaded files: {files}.',
            missingFields: '{fields} is required.',
            InvalidIPC: 'Invalid trademark registration document or incorrect file type.',
            InvalidDomainDOC: 'Invalid Saudi domain registration document or incorrect file type.',
            SenderIDMismatchDelegationLetter: 'Sender Name does not match the sender name in the delegation letter.'
        },
        alerts: {
            validationFailed: 'Validation failed',
            CRNameMismatch: 'Sender Name does not match the trade name from the Commercial Registration document.',
            HRSDNameMismatch: 'Sender Name does not match the trade name from the HRSD document.',
            AuthorizationNameMismatch: 'Sender Name does not match the trade name from the Delegation Letter.',
            MissingBrandName: 'Brand Name could not be extracted from the trademark registration.',
            IPCOwnerNameMismatch: 'The owner of the Brand Name in the Trademark Registration does not match the entity name in the Commercial Registration Certificate.',
            MissingOrInvalidIPCDocumentForDomainMatch: 'Sender Name is shorter than 4 characters and there is no Trademark registration to verify it against the Saudi domain registration.',
            VerifyBrandOwnershipViaIPC: 'Sender Name does not match the document name. Need a valid Trademark Registration for further validation.',
            VerifyDomainCertificate: 'Sender Name does not match the Delegation Letter and is shorter than 4 letters. Need a valid Saudi domain registration for further validation.',
            DomainAndSenderDoNotMatchIPBrand: 'Sender Name does not match both the Saudi domain registration and the brand name.',
            BrandNameMismatch: 'Sender Name does not match the Brand name from the Trademark Registration.',
            InvalidSenderType: "Invalid sender type. Must be 'White List' or 'Advertising'.",
            InvalidFileType: 'Invalid file type. Allowed types are PDF and images.',
            InvalidEntityType: 'Invalid entity type. Allowed types are Government, Private, or Charity.',
            InternalProcessingFailed: 'An internal error occurred during processing.',
            savingFailed: 'Error saving uploaded files: {files}.',
            missingFields: '{fields} is required.',
            InvalidIPC: 'Invalid trademark registration document or incorrect file type.',
            InvalidDomainDOC: 'Invalid Saudi domain registration document or incorrect file type.',
            SenderIDMismatchDelegationLetter: 'Sender Name does not match the sender name in the delegation letter.'
        },
        rejectionReason: {
            addNewReason: 'Add New Reason',
            requestType: 'Request Type',
            rejectionText: 'Rejection Reason',
            rejectionReasonList: 'Rejection Reason List',
            editRejectionReasonSuccessfully: 'Edit Rejection Reason Successfully',
            addRejectionReasonSuccessfully: 'Add Rejection Reason Successfully',
            deleteRejectionReasonSuccessfully: 'Delete Rejection Reason Successfully'
        },
        senderComplaints: {
            noActionCanBeTakenOnThisBecauseTheSenderNameIsDeleted: 'No action can be taken on this because the sender name is deleted.',
            complaintEditedSuccessfully: 'Complaint Edited Successfully',
            complaintClosedSuccessfully: 'Complaint Closed Successfully',
            complaintDeactivatedsuccessfully: 'Complaint Deactivated Successfully',
            closeComplaintInputText: 'Are you sure you want to close the selected complaint?',
            deactivateComplaint: 'Deactivate Complaint',
            deactivateComplaintInputText: 'Are you sure you want to deactivate the selected sender?',
            closeComplaint: 'Close Complaint',
            pendingForReview: 'Pending For Review',
            deactivated: 'Deactivated',
            falseComplaint: 'False Complaint',
            reactivated: 'Reactivated',
            complaintStatus: 'Complaint Status',
            notAllSenderAreDeactivated: 'Not All Sender Are Deactivated',
            complaintId: 'Complaint Id',
            reactivate: 'Reactivate',
            providerName: 'Provider Name',
            provider: 'Provider',
            createdDate: 'Created Date',
            requestDate: 'Request Date',
            reactivatedsuccessfully: 'Reactivated Successfully',
            deactivate: 'Deactivate',
            requests: 'Requests',
            senders: 'Senders',
            activated: 'Activated',
            senderNameSearch: 'Sender name',
            status: 'Status',
            of: 'of',
            daysLeft: 'days left',
            senderName: 'Sender Name',
            newRequest: 'New request',
            clientName: 'Client Name',
            details: 'Details',
            groupedSenderComplaints: 'Complaints details',
            transactionCommunicationNumber: 'TCN',
            tcnNumber: 'Tcn Number',
            groupedTableSenderName: 'Sender name',
            groupedTableSenderType: 'Sender Type',
            complaintDate: 'Complaint Date',
        },
        loginPage: {
            aPIUser330: 'Users With 330API User Type Can Not Login',
            logoTextMain: 'MSG Stack',
            serviceuser: 'Users With Service Type Can Not Login',
            cstTaguser: 'Users With CST Tag Name Type Can Not Login',
            logoTextSub: 'SMS Management system',
            loginHeader: 'Login to my account',
            loginNote1: 'Please, use your account credential to login to the platform',
            verfiy: 'Verfiy',
            verfiyOTP: 'Verfiy OTP',
            resendOtp: 'Resend OTP',
            invalidOTP: 'Invalid OTP',
            enterOtp: 'Please, please Enter Otp to login to the platform',
            OtpReminingTime: 'OTP Will be expired after',
            invalidResponseTime: 'Invalid response time',
            unableToLogin: 'Unable To Login',
            userName: 'User Name',
            password: 'Password',
            currentPassword: 'Current Password',
            newPassword: 'New Password',
            confirmPassword: 'Confirm Password',
            canNotLogin: 'I can’t login to my account',
            login: 'Login',
            restoreMyPassword: 'Restore my password',
            changePassword: 'Change Password',
            restoreNote1: 'We will reset the password for your account by sending a new password to your email through this process.',
            restoreNote2: 'Do want to proceed?',
            backToLoginForm: 'Back to login form',
            yesUnderstand: 'Yes, I understand',
            pleaseInsertEmail: 'Please, insert your User Name',
            email: 'Email',
            sendVerificationCode: 'Send verification code',
            sendPassword: 'Send Password',
            verificationNote1: 'Verification code has been send to your email',
            verificationNote2: 'Please, insert the verification code',
            resendCodeAgain: 'Resend Code again',
            verify: 'Verify',
            setPasswordNote1: 'Verification code verified',
            setPasswordNote2: 'Please, insert your new password',
            setNewPassword: 'Set new password',
            captchaRequired: 'Please complete the security verification and try again.',
            passwordResetedSuccessfully: 'Password reseted successfully',
            backToLogin: 'Back to login',
            updateShortCodeType: 'The short code has been updated and a short code type has been added to it. Please view and modify it through its own page',
        },
        dashboardPage: {
            displayId: 'Request Id',
            displayContracts: 'Display Contracts',
            contractFind: 'Display Contracts',
            contractDateBy: 'Contract Date By',
            finalApprove: 'Final Approve',
            review: 'review',
            someContractsAreMergeInserted: 'Some Contracts Are Merge Inserted',
            templateName: 'Template Name',
            senderExpiryDate: 'Sender Expiry',
            expiryDate: 'Expiry Date',
            comment: 'Comment',
            active: 'Active',
            verify: 'Verify',
            requestId: 'Request Id',
            providerName: 'Provider Name',
            provider: 'Provider',
            createdDate: 'Created Date',
            requestDate: 'Request Date',
            all: 'All',
            approved: 'Approved',
            paid: 'Paid',
            deactivate: 'Deactivate',
            deactivated: 'Deactivated',
            expired: 'Expired',
            requests: 'Requests',
            senders: 'Senders',
            thisMonth: 'This month',
            partially: 'Partially',
            edit: 'Edit',
            ConnectivityDetail: 'Connectivity Detail',
            activated: 'Activated',
            inactive: 'Inactive',
            pendingFor: 'Pending for',
            payment: 'Payment',
            approval: 'Approval',
            rejected: 'Rejected',
            senderNameSearch: 'Sender name',
            NotAllSenderActivateOrPartiallyActivated: 'Not All selected Senders are Activate Or Partially Activated',
            representativeName: 'Representative Name',
            representativeMobile: 'Representative Mobile',
            representativeEmail: 'Representative Email',
            deactivatedsuccessfully: 'Deactivated Successfully',
            criticalSenderSavedSuccessfully: 'Critical Sender updated successfully',
            status: 'Status',
            of: 'of',
            daysLeft: 'days left',
            renew: 'Renew',
            renewContract: 'Renew Contract',
            extendSenderDuration: 'Extend Sender Duration',
            pause: 'Pause',
            sendRemainder: 'Send remainder',
            terminate: 'Terminate',
            senderName: 'Sender Name',
            newRequest: 'New request',
            clientName: 'Client Name',
            operatorStatus: 'Operator Status',
            details: 'Details',
            Approve: 'Approve',
            reject: 'Reject',
            Pay: 'Pay',
            NotAllSenderCanBeRejected: 'Not All Selected Senders Can Be Rejected',
            NotAllSenderPendingApproval: 'Not All Selected Senders Are Pending for Approval',
            NotAllRequestsPendingApproval: 'Not All Selected Requests Are Pending for Approval',

            Approvedsuccessfully: 'Senders Has been Approved successfully',
            RequestApprovedsuccessfully: 'Requests Has been Approved successfully',

            Rejectedsuccessfully: 'Senders Has been Rejected successfully',
            RequestRejectedsuccessfully: 'Request Has been Rejected successfully',
            NotAllSenderRequestRelatedToThisTenant: 'Not All Sender Requests Related To This Tenant',
            providerAlreadyRejected: 'The request has already been rejected by the provider',
            "providerRejectTimeExpired": 'The allowed time to reject this request has expired',
            NotAllSenderPendingPay: 'Not All Selected Senders Are Pending for Pay',
            Paysuccessfully: 'Paid successfully',
            rejectreason: 'Reject Reason',
            resend: 'Resend',
            exportToExcel: 'Export All Senders To Excel',
            exportRequestsToExcel: 'Export All Requests To Excel',
            NotAllSenderRejected: 'Not All Selected Sender status Rejected',
            NotAllTemplateRejected: 'Not All Selected Template status Rejected',
            resentSuccessfully: 'Resent Successfully',
            checkSender: 'Check',
            checkAvailability: 'Check Availability',
            senderNotFound: 'Sender Not Found',
            NotAllRequestsCanBeDeleted: 'Not All Selected Requests Can Be Deleted',
            NotAllRequestsCanBeDeactivated: 'Not All Selected Requests Can Be Deactivated',
            RequestDeletedSuccessfully: 'Request Deleted Successfully',
            RequestDeactivatedsuccessfully: 'Request Deactivated Successfully',
        },
        userManagementPage: {
            users: 'Users',
            providerName: 'Provider Name',
            OperatorName: 'Operator Name',
            UserPassword: 'User Password',
            AddUserSuccessfully: 'User Added Successfully',
            EditUserSuccessfully: 'User edited  successfully',
            requestSubmittedSuccessfully: 'The request has been submitted successfully',
            EditUserStatusSuccessfully: 'User status edited successfully',
            resendPasswordEmailSuccessfully: 'Sent password by email successfully',
            monitorDashboard: 'Monitor Dashboard',
            monitorDashboardConfirmationTitle: "Confirm Monitor Dashboard Visibility",
            monitorDashboardConfirmationText: "Are you sure you want to {action} the Monitor Dashboard for user \"{user}\"?",
            monitorDashboardToggled: "Monitor Dashboard toggled Successfully",
            export: 'Export',
            exportSuccess: 'Report exported successfully',
            exportFailed: 'Could not export the report',
        },
        extendDurationRequestsPage: {
            renew: 'Renew',
            extendRequestId: 'Extend Request Id',
            extendDuration: 'Extend Duration',
            pay: 'Pay',
            senderName: 'Sender Name',
            requestDate: 'Request Date',
            status: 'Status',
            actions: 'Actions',
            extendDurationRequests: 'Extend Duration Requests',
            requests: 'Requests',
        },
        updateDataRequestsPage: {
            requestId: 'Request Id',
            senderName: 'Sender Name',
            clientName: 'Client Name',
            updateType: 'Update Type',
            representativeName: 'Representative Name',
            requestDate: 'Request Date',
            status: 'Status',
            requests: 'Requests',
            clientData: 'Client Data',
            comparison: 'Changed Fields',
            fieldName: 'Field Name',
            currentInformation: 'Current Information',
            requestedInformation: 'Requested Information',
            updateRequestDetails: 'Update Request Details',
            reviewChangesSubtitle: 'Review the changes requested by the provider.',
            currentInformationBefore: 'Current Information (Before Update)',
            requestedInformationAfter: 'Requested Information (After Update)',
            commentsOptional: 'Comments (Optional)',
            addCommentsPlaceholder: 'Add your comments here...',
            providerComment: 'Provider Comment',
            approvalComment: 'Approval Comment',
            nothingChanged: 'No updates have been made',
            approveConfirm: 'Are you sure you want to Approve the selected Request?',
            rejectConfirm: 'Are you sure you want to reject the selected Request?',
            representativeDataUpdate: 'Representative data update',
        },
        providerPage: {
            providersList: 'Providers list',
            addNewProvider: 'Add new provider',
            providerSearch: 'Provider name, ID search',
            addingDate: 'Adding Date',
            otpReminingTime: 'Otp Remining Time',
            confirmDisconnecting: 'To Confirm Disconnecting All The Shortcodes Kindly Enter The OTP Sent To Your Email.',
            confirmConnecting: 'To Confirm Connecting All The Shortcodes Kindly Enter The OTP Sent To Your Email.'
        },
        shortPage: {
            shortCodeList: 'Short code list',
            addNewShortCode: 'Add new short code',
            company: 'Company',
            shortCode: 'Short code',
            addShortCode: 'Add short code',
            editShortCode: 'Edit short code',
            companyName: 'Company Name',
            selectCompany: 'Select company',
            selectShortCode: 'Select short code',
            operatorSearch: 'Operator name, ID search',
            shortcodeSearch: 'short Code name, ID search',
            shortcodeType: 'Short Code Type',
            selectType: 'Select short code type',
            whiteList: 'White List',
            blackList: 'Black List',
            providerName: 'Provider name',
            confirmDisconnect: "Confirm Disconnect OTP",
            otpMessage: "To confirm disconnecting the selected shortcode from all sender names, please enter the OTP sent to your registered email.",
            remaningDays: 'Sender Expiring in',
            contractExpiryDate: 'Contract Expiring in',
            disconnectedSuccessfully: 'All Sender Names  Disconnected Successfully.',
            confirmDeleteShortCode: 'Confirm delete short code',
            deleteOtpMessage: 'To confirm deleting the selected short code, enter the 6-digit OTP sent to your email. You can resend after the countdown reaches zero (5 minutes).',
            deleteShortCodeSuccess: 'Short code deleted successfully.',
            otpRemainingTimeLabel: 'Remaining time',
            resendOtpButton: 'Resend OTP',
            verifyOtpButton: 'Verify OTP',
            confirmDisconnectTitle: 'Disconnect Short Code',
            confirmDisconnectMessage: 'Are you sure you want to disconnect the selected Short Code?',
            shortCodeNumbersOnly: 'Short code must contain numbers only',
        },
        senderInfo: {
            comment: 'Comment',
            requestStatus: 'Request Status',
            status: 'Status',
            createdDate: 'Date',
            dateTime: 'Date & Time',
            processedBy: 'Processed by',
            system: 'System',
            dueToComplaint: 'Due to a complaint',
            manualDeactivation: 'Manual deactivation',
            manualDeletion: 'Manual Deletion',
            noActivityHistory: 'No activity history found for this sender.',
            rejectionReason: 'Rejection Reason',
            extendRequestId: 'Extend Request Id',
            duration: 'Duration'
        },
        scamPage: {
            scamList: "Scam List",
            newScamList: "New Scam List",
            senderName: 'Sender Name',
            clientName: 'Client Name',
            scamId: 'ScamId'
        },
        bulkshortPage: {
            skippedSenders: "Skipped Senders:",
            shortCodeConnectivityRequest: "Short code Connectivity Request",
            selectConnectivityStatus: "Select Connectivity Status",
            selectRequestStatus: 'Select Request Status',
            addNewConnectivity: 'Add New Connectivity',
            added: 'Added',
            pendingAddition: 'Pending Addition',
            completed: 'Completed',
            inProgress: 'In Progress',
            operatorName: 'Operator Name',
            shortCode: 'ShortCode',
            senderTotal: 'Sender Total',
            senderSkipped: 'Sender Skipped',
            of: 'Of',
            senderLeft: 'Sender Left',
            ok: 'Ok',
            shortcodeType: 'Shortcode Type',
            shortcode: 'Shortcode',
            selectOperator: 'Select Operator',
            selectType: 'Select Type',
            selectShortCode: 'Select Shortcode',
            requestStatus: 'Request Status',
            connectivityStatus: 'Connectivity Status',
            addNewConnectingRequestServiceSuccessfully: 'Add New Connecting Request Successfully',
            shortcodeConnectingRequest: 'Shortcode Connecting Request',
            linkInfo: 'Link Info',
        },
        employeeStatistics: {
            allProcessingRequests: 'All Processing Requests',
            finalApprovedProcessingRequests: 'Final Approved Processing Requests',
            approvedProcessingRequests: 'Approved Processing Requests',
            rejectedProcessingRequests: 'Rejected Processing Requests',
            requests: 'Requests',
            exportToExcel: 'Export To Excel',
            requestId: 'Request Id',
            senderName: 'Sender Name',
            processingBy: 'Processing By',
            processingDateFrom: 'Processing Date From',
            processingDateTo: 'Processing Date To',
            processingDate: 'Processing Date',
            processingResult: 'Processing Result',
            requestType: 'Request Type'
        },
        monitorDashboard: {
            requests: 'Requests',
            notifications330: '330 Notifications',
            requestsDashboard: 'Requests Dashboard',
            notifications330Dashboard: '330 Notifications Dashboard',
            allComplaints: 'All Complaints',
            pendingComplaints: 'Pending Complaints',
            resolvedComplaints: 'Resolved Complaints',
            complaintsProcessingAverage: 'Complaints Processing Average',
            notifications: 'Notifications',
            overview: 'Overview',
            senderNames: 'Sender Names',
            createdDate: 'Created Date',
            from: 'From',
            to: 'To',
            requestType: 'Request Type',
            requestStatus: 'Request Status',
            customerType: 'Customer Type',
            smsServiceProvider: 'SMS Service Provider',
            serviceProvider: 'Service Provider',
            all: 'All',
            senderRequest: 'Sender Request',
            contractRequest: 'Contract Request',
            government: 'Government',
            private: 'Private',
            charity: 'Charity',
            requestsWithinSla: 'Requests within SLA',
            requestsExceededSla: 'Requests Exceeded SLA',
            approvalProcessingAverage: 'Approval Processing Average',
            paymentProcessingAverage: 'Payment Processing Average',
            activationProcessingAverage: 'Activation Processing Average',
            processingWithin2BusinessDays: 'Processing within 2 business days',
            processedIn3OrMoreBusinessDays: 'Processed in 3 or more business days',
            daysSuffix: 'days',
            allRequests: 'All Requests',
            allRequestsDetailsTitle: 'All Requests Details',
            allRequestsDetailsEmpty: 'No requests match the current filters.',
            requestTimelineDetailsTitle: 'Request Timeline Details',
            requestTimelineDetailsEmpty: 'No requests match the current filters.',
            delayedRequestsDetailsTitle: 'Delayed Requests Details',
            delayedRequestsDetailsEmpty: 'No delayed requests match the current filters.',
            delayedDays: 'Delayed Days',
            requestTimelineByCustomerTypeDetailsTitle: 'Requests Timeline by Customer Type Details',
            requestTimelineByCustomerTypeDetailsEmpty: 'No requests match the current filters.',
            exportToExcel: 'Export to Excel',
            requestId: 'Request Id',
            senderName: 'Sender Name',
            senderType: 'Sender Type',
            clientName: 'Client Name',
            senderExpiryDate: 'Sender Expiry Date',
            forever: 'Forever',
            requestTypeNewSender: 'New Sender',
            requestTypeUseSender: 'Use Sender',
            requestTypeNewContract: 'New Contract',
            requestTypeRenewContract: 'Renew Contract',
            requestTypeContract: 'Contract',
            requestTimeline: 'Request Timeline',
            requestTimelineByCustomerType: 'Requests Timeline by Customer Type',
            total: 'Total',
            pendingApproval: 'Pending Approval',
            approved: 'Approved',
            rejected: 'Rejected',
            paid: 'Paid',
            expired: 'Expired',
            deleted: 'Deleted',
            deactivated: 'Deactivated',
            customerTypeLabel: 'Customer type',
            requestsCountLabel: 'Requests',
            senderNameLengthCompliance: 'Sender Name Length Compliance',
            compliance: 'Compliance',
            sendersByNodes: 'Senders By Nodes',
            sendersDuration: 'Senders Duration',
            sendersExpirationTimeline: 'Sender Expiration Timeline',
            senderExpirationLegend: 'Sender',
            sendersRenewalTimeline: 'Senders Renewal Timeline',
            activeSendersTimeline: 'Active Senders Timeline',
            activeSendersTimelineDetailsTitle: 'Active Senders Timeline Details',
            activeSendersTimelineDetailsEmpty: 'No active senders match the current filters.',
            senderExpirationTimelineDetailsTitle: 'Sender Expiration Timeline Details',
            senderExpirationTimelineDetailsEmpty: 'No senders match the current filters.',
            senderRenewalTimelineDetailsTitle: 'Sender Renewal Timeline Details',
            senderRenewalTimelineDetailsEmpty: 'No renewal requests match the current filters.',
            sendersDurationDetailsTitle: 'Sender Duration Details',
            sendersDurationDetailsEmpty: 'No senders match the current filters.',
            sendersByNodesDetailsTitle: 'Senders by Nodes Details',
            sendersByNodesDetailsEmpty: 'No senders match the current filters.',
            senderNameLengthComplianceDetailsTitle: 'Sender Name Length Compliance Details',
            senderNameLengthComplianceDetailsEmpty: 'No senders match the current filters.',
            senderNameLengthColumn: 'Sender Name Length',
            isCompliant: 'Is Compliant',
            senderNameDuration: 'Sender Name Duration',
            renewalDuration: 'Renewal Duration',
            requestsBySmsProviderAndSenderType: 'Requests by SMS Service Provider and Sender Type',
            requestsBySmsProviderAndSenderTypeDetailsTitle: 'Requests by SMS Service Provider and Sender Type Details',
            requestsBySmsProviderAndSenderTypeDetailsEmpty: 'No senders match the current filters.',
            sendersRenewalYAxis: 'Number of sender renewal requests',
            sendersRenewalTooltipCount: 'Sender renewal requests',
            activeSendersTooltipCount: 'Active senders',
            sendersExpiringAxisLabel: 'Number of sender names expiring',
            years: 'Years',
            loading: 'Loading...',
            noDataAvailable: 'No data available',
            delayedRequests: 'Delayed Requests',
            noDelayedRequestsAvailable: 'No delayed requests available',
            invalidDateRange: 'Start date must be on or before end date.',
            retryLoad: 'Retry',
            emptyChartTitle: 'Nothing to display for these filters',
            emptyChartHintFilters: 'Widen the created date range or set SMS provider, service provider, and customer type to All, then click Apply.',
            emptyChartHintReset: 'You can also use Reset to restore the default date range (from launch to today).',
            emptyTimelineTitle: 'No monthly request volume in this range',
            emptyChartHintDateRange: 'Try extending the start date toward 2022-02-01 or the end date toward today.',
            emptyStackedTimelineTitle: 'No requests by customer type in this period',
            emptyChartHintCustomerType: 'If Customer Type is not All, clear it to see the full mix.',
            scrollWideChartHint: 'This chart scrolls horizontally — use the scrollbar or swipe to see all periods.',
            emptyDelayedTitle: 'No delayed requests for this view',
            emptyDelayedHint: 'Either there are no delayed items, or filters exclude every provider row.',
            emptySendersTitle: 'No sender duration data',
            emptySendersDurationHint: 'Confirm paid senders exist in the period; duration uses the latest paid request per sender.',
            emptySendersByNodesTitle: 'No senders by node',
            emptySendersByNodesHint: 'Paid senders are counted per node; try All tenants or a broader date range.',
            emptyComplianceTitle: 'No compliance breakdown',
            emptyComplianceHint: 'Compliance is computed from active senders in range — expand dates or clear tenant filters.',
            emptyProviderSenderTitle: 'No provider and sender-type mix',
            emptyProviderSenderHint: 'Include more providers by clearing the SMS filter or widening dates.',
            emptyRenewalTimelineTitle: 'No renewal activity in this window',
            emptyRenewalTimelineHint: 'Renewals appear when matching requests exist; broaden the created date range.',
            emptyExpirationTimelineTitle: 'No expirations in the forward window',
            emptyExpirationTimelineHint: 'Expiration buckets are forward-looking; adjust filters if the range is very narrow.',
            emptyActiveSendersTimelineHint: 'Active senders follow lifecycle windows; broaden created-date filters to include more requests.',
            noRequestsDataFor: 'No Available Requests for {chartName} chart',
            noRequests: 'No Available Requests',
            noSenderssDataFor: 'No Available Senders for {chartName} Chart',
            noMonitorDashboardChartDataFor: 'No chart data available for the {chartName}.',
            complaintsStatuses: 'Complaints statuses',
            complaintsStatusesDetailsTitle: 'Complaints Statuses Details',
            complaintsStatusesTooltipCount: 'Number of complaints',
            complaintFrequencyPerSender: 'Complaint Frequency per Sender Name',
            complaintFrequencyPerSenderDetailsTitle: 'Complaint Frequency per Sender Name Details',
            complaintFrequency: 'Complaint Frequency',
            complaintFrequencyTooltipSenderName: 'Sender name',
            complaintFrequencyTooltipComplaintStatus: 'Complaint status',
            complaintStatus: 'Complaint Status',
            complaintsTimeline: 'Complaints Timeline',
            complaintsTimelineDetailsTitle: 'Complaints Timeline Details',
            complaintsTimelineDetailsEmpty: 'No complaints match the current filters.',
            complaintsTimelineTooltipReceived: 'Complaints received',
            complaintsCountLabel: 'Complaints',
            statusPendingForReview: 'Pending for review',
            statusDeactivated: 'Deactivated',
            statusFalseComplaint: 'False Complaint',
            statusReactivated: 'Reactivated',
            emptyComplaintsStatusesTitle: 'No data available',
            emptyComplaintsStatusesHint: 'There are no complaints in the selected period. Adjust the date range or filters, then click Apply.',
            emptyComplaintsTimelineTitle: 'No data available',
            emptyComplaintsTimelineHint: 'There are no complaints in the selected period. Adjust the date range or filters, then click Apply.',
            emptyComplaintFrequencyTitle: 'No data available',
            emptyComplaintFrequencyHint: 'There are no complaints for any sender in the selected period. Adjust filters and click Apply.',
        },
    },
    ar: {
        operator_1: 'Zain',
        operator_2: 'STC',
        operator_3: 'Mobily',
        operator_4: 'Salam',
        'Short Code is used by a Sender': 'الرمز القصير مستخدم من قبل اسم مرسل ولا يمكن حذفه قبل إكمال الفصل أو إزالة الربط.',
        shared: {
            employeeStatistics: 'Employee Statistics',
            tenant: 'Tenant',
            favorite: 'Favorite',
            unfavorite: 'Unfavorite',
            favoriteInputText: 'Are you sure you want to  favorite this client?',
            unfavoriteInputText: 'Are you sure you want to  unfavorite this client?',
            clientFavoriteSuccessfully: 'Client Favorite Successfully',
            clientUnfavoriteSuccessfully: 'Client Unfavorite Successfully',
            pendingForReview: 'Pending For Review',
            deactivated: 'تم التعطيل',
            thisSenderOriginallyOnlyHasWarningSenderType: 'This Sender Originally Only Has Warning Sender Type.',
            finalApprovedsuccessfully: 'Final Approved Successfully',
            finalApproveInputText: 'Are you sure you want to Final Approve the selected Senders?',
            finalApproveInput: 'Final Approve',
            review: 'review',
            renewContractRequest: 'Renew Contract Request',
            renewalInfo: 'Renewal Info',
            sendersRenewal: 'Senders Renewal',
            action: 'Action',
            deleteHistory: 'Are you sure you want to delete this history?',
            deleteHistorySuccessfully: 'Delete History Successfully',
            pendingPayment: 'Pending Payment',
            autoVerificationCompletedSuccessfully: 'Auto Verification Completed Successfully',
            representativeID: 'Representative ID',
            addHistoryInputText: 'Are you sure you want to add this history?',
            addHistory: 'Add History',
            requestHistorySuccessfully: 'Request History Added Successfully.',
            historyDate: 'History Date',
            manual: 'Manual',
            auto: 'Auto',
            iHaveTrademark: 'I Have a Trademark',
            domainName: 'Domain Name',
            trademarkName: 'Trademark Name',
            protectionDateFrom: 'Protection Date From',
            protectionDateTo: 'Protection Date To',
            trademarkRequired: 'Trademark Required',
            invalidDateRange: 'Invalid Date Range',
            domainNameRequiredFor: 'Domain Name Required For',
            addingType: 'Adding Type',
            Operator: 'Operator',
            autoActivationNote: 'When you choose auto that will be connect all short code based on( sender type and operator)',
            connectivityAdding: 'Connectivity Adding',
            reactivateInput: 'Reactivate',
            reactivateInputText: 'Are you sure you want to reactivate the selected Senders?',
            complaintID: 'Complaint ID',
            senderComplaintsList: 'Sender Complaints List',
            aPIUser330: '330API User',
            skipped: 'Skipped',
            contractExpiryDate: 'Contract Expiry Date',
            attachmentList: 'Attachments List',
            canNotAddArequestWithoutADelegationLetter: 'Can Not Add A Request Without A Delegation Letter Attachment',
            canNotAddArequestWithoutCommercialRegistrationAttach: 'Can Not Add A Request Without Commercial Registration Attachment',
            canNotAddArequestWithoutHRSDLicenseAttach: 'Can Not Add A Request Without HRSD License Attachment',
            attachment: 'Attachment',
            noAttachments: 'No Attachments',
            addCategory: 'Add Category',
            other: 'Other',
            providerStatus: 'Provider Status',
            expireDate: 'Expiry Date',
            integrationBaseURL: 'Integration Base URL',
            integrationApiKey: 'Integration API Key',
            isIntegrated: 'Is Integrated',
            RejectionReason: 'Rejection Reason',
            canceled: 'Canceled',
            senderExpiryDate: 'Sender Expiry Date',
            customDayMustBeLargerThanTheEnteredValue: 'Custom Day Must Be Larger Than The Entered Value',
            customDaySearchMustBeUsingANumber: 'Custom Day Search Must Be Using a Number.',
            scamAddSuccessfully: 'Scam Added Successfuly',
            deleteScamSuccessfully: 'Scam Deleted Successfuly',
            editScamSuccessfully: 'Scam Edited Successfuly',
            theMaximumSizeForTheAttachmentIs3Megabytes: 'The maximum size for the attachment is 3 megabytes',
            fileSizeExceedsTheLimit: 'File Size Exceeds The Limit',
            days: ' Days',
            daysAndMore: ' Days and more',
            from: 'From : ',
            to: 'To :  ',
            allActiveSenders: 'All Active Senders',
            pendingActivationRequests: 'Pending Activation Requests',
            renewSender: 'Renew Sender',
            operatorStatus: 'Operator Status',
            sorryUnrecognizedRequestStatus: 'Sorry! Unrecognized Request Status',
            shortCodeEditDisabled: 'Short Code Type can not be edited because it is already connected to a sender',
            senderCriticality: 'Sender Criticality',
            notCritical: 'Not Critical',
            critical: 'Critical',
            criticalSender: 'Critical Sender',
            publicPaymentDisclaimer: 'لا تتحمل شركة حوسبة التقنية لتقنية المعلومات أي مسؤولية ناتجة عن بيانات العميل في النظام، بما في ذلك، على سبيل المثال لا الحصر، ما يتعلق بدقة أو صحة أي بيانات العميل. وفي جميع الأحوال، لا تتحمل شركة حوسبة التقنية لتقنية المعلومات أي مسؤولية، تجاه أي زوار أو أطراف ثالثة فيما يتعلق بالبيانات المدخلة من قبلهم.',
            sadadNumberCreatedSuccessfully: 'Sadad Number Created Successfully',
            sadadNumber: 'Sadad Number',
            getSadadNumber: 'Get Sadad Number',
            status: 'Status',
            lockProviderInput: 'Provider status change',
            lockProviderInputText: 'Are you sure you want to lock the selected provider?',
            unlockProviderInputText: 'Are you sure you want to unlock the selected provider?',
            editProviderStatusSuccessfully: 'Provider status edited successfully',
            extend: 'Extend',
            extendRequestTypeInput: 'Extend Request',
            extendInputText: 'Are you sure you want to extend duration for this senders ?',
            showExtendRequest: 'Show Extend Request',
            extendRequest: 'Extend Request',
            extendDurationRequests: 'Extend Duration Requests',
            extendRequestedSuccessfully: 'Extend Requested Successfully',
            senderConnectivity: 'Sender Connectivity',
            company: 'Company',
            zain: 'Zain',
            mobily: 'Mobily',
            sTC: 'STC',
            salam: 'Salam',
            exportToExcel: 'Export To Excel',
            selectCompany: 'Select Company',
            balanceInvoice: 'Balance Invoice',
            invoiceCreatedSuccessfully: 'Invoice Created Successfully',
            createInvoiceInputText: 'Do you want to issue a balance invoice for this transaction?',
            activation: 'Activation',
            isActive: 'Is Active',
            activationDate: 'Activation Date',
            activationInformation: 'Activation Information',
            trackRequest: 'Track Request',
            rejectionReasonOrComment: 'Rejection Reason/Comment',
            comment: 'التعليق',
            commentMinLength: 'يجب أن يكون التعليق 3 أحرف على الأقل',
            mobilyActivationDate: 'Mobily Activation Date',
            salamActivationDate: 'Salam Activation Date',
            sTCActivationDate: 'STC Activation Date',
            zainActivationDate: 'Zain Activation Date',
            lebaraActivationDate: 'Lebara Activation Date',
            requestId: 'Request Id',
            connectivityActivationReport: 'Connectivity Activation Report',
            connectivityStatus: 'Connectivity Status',
            numberOfActions: 'Number Of Actions',
            SenderRequestActionsInput: 'Request Actions',
            showSenderRequestActions: 'Show Sender Request Actions',
            showSenderActivityHistory: 'سجل نشاط اسم المرسل',
            senderActivityHistory: 'سجل نشاط اسم المرسل',
            showRequestActions: 'Show Request Actions',
            senderRequestPaymentTransactions: 'Sender Request Payment Transactions',
            paymentStatus: 'Payment Status',
            senderRequestApprovalHistory: 'Sender Request Approval History',
            transactionReference: 'Transaction Reference',
            checkOutId: 'Checkout Id',
            creditLimitPayment: 'CreditLimit Payment',
            isMada: 'Is Mada',
            userId: 'User Id',
            senderRequestSupport: 'Sender Request Support',
            requestType: 'Request Type',
            changedProperty: 'Changed Property',
            approvalHistory: 'Approval History',
            paymentTransactions: 'Payment Transactions',
            creditCardVisaMastercard: 'Credit Card (Visa,Mastercard)',
            debitCardMada: 'Debit Card(Mada)',
            createPaymentLinkVisaMastercard: 'Create Payment Link (Visa,Mastercard)',
            slaNote1: '* Requests of three characters or less require more time, up to 5 working days',
            slaNote2:
                '** If the operator or system developer requires more time, then Hawsaba will notify the client - within 2 working days- with updated response time.',
            problemsWithASpecificSIDOrLinkWithOperators: 'problems with a specific SID or link with operators',
            workingDays2: '2 working days**',
            technicalSupport: 'Technical support',
            workingDay2: '2 working days*',
            processingARequestWithAcceptanceOrRejectionBasedOnTheRegistrationCriteria:
                'Processing a request with acceptance or rejection based on the registration criteria',
            sIDRequest: 'SID Request',
            three: '3',
            two: '2',
            one: '1',
            workingDay1: '1 working day',
            inquiriesAboutTheSystemOrAboutAdmissionCriteria: 'Inquiries about the system or about admission criteria',
            inquiries: 'Inquiries',
            description: 'Description',
            responseTime: 'Response Time',
            sla: 'SLA',
            paymentDate: 'Payment Date',
            expiryDate: 'Expiry Date',
            details: 'Details',
            provider: 'Provider',
            updateRequestDataInputText: 'Are you sure you want to Update Sender Request Data?',
            updateDataRequests: 'Update Requests',
            updateRequestData: 'Update Request Data',
            view: 'عرض',
            thisFieldIsRequired: 'This field is required.',
            noDataFound: 'No Data Found.',
            updateRequestCreatedSuccessfully: 'Update request created successfully',
            updateContractRequest: 'Edit contract request',
            updateMessageTemplateRequest: 'Edit Message Template Request',
            convertToAdded: 'Convert To Added',
            markAsAddedInputText: 'Are you sure you want to convert status of the selected Connectivity to added?',
            convertToDeleted: 'Convert To Deleted',
            markAsDeletedInputText: 'Are you sure you want to convert status of the selected Connectivity to Deleted?',
            resendToOperator: 'Resend To Operator',
            resendToOperatorInputText: 'Are you sure you want to Resend the selected Connectivity to Operator?',
            convert: 'Convert',
            resend: 'Resend',
            myProfileInfo: 'My Profile Information',
            myProfile: 'My Profile',
            Paid: 'Paid',
            requestStatus: 'Request Status',
            createddate: 'Created Date',
            InvalidMobileNumber: 'Invalid Mobile Number',
            InvalidIdNumber: 'Invalid Id Number',
            invoiceUnderProcessing: 'Invoice Under Processing',
            ToAddTypeAdvertisementSendernameShouldBeLessThanOrEqual8: 'To Add Type Advertisement Sender name Should Be Less Than Or Equal 8',
            ToAddTypeServiceWithCustomerTypeInternationalSendernameShouldBeLessThanOrEqual8: 'To Add Type Service With Customer Type International Sender name Should Be Less Than Or Equal 9',
            invoiceNumber: 'Invoice Number',
            FaildToEnterPaymentPage: 'Not all senders names are ready to pay',
            organizationName: 'Organization Name',
            clientInformation: 'Client Information',
            senderInformation: 'Sender Information',
            templateInformation: 'Template Information',
            referenceNumber: 'Reference Number',
            copyLink: 'Copy Link',
            createPaymentLink: 'Create Payment Link',
            invoicesList: 'Invoices List',
            paymentdate: 'Payment Date',
            sendersName: 'Senders Names',
            amount: 'Amount',
            Invoices: 'Invoices',
            InvoicesNumber: 'Invoices Number',
            editProviderFinanceInfo: 'Edit Provider Finance Information',
            providersFinance: 'Providers Finance Info',
            BalanceInvoice: 'Balance Invoices',
            balance: 'Balance',
            CreditLimitTransaction: 'Credit Limit Transaction',
            creditLimitAmount: 'Credit Limit Amount',
            fellInfo: 'can you fill the following information about the provider',
            Conectivitylog: 'Connectivity log',
            shortcode: 'Short Code',
            ConvertStatus: 'Convert Status',
            addRequest: 'Add Request',
            ConvertedSuccessfully: 'Converted Successfully',
            addResponse: 'Add Response',
            deleteRequest: 'Delete Request',
            deleteResponse: 'Delete Response',
            lastModifiedDate: 'Last Modified Date',
            deleteSuccessfully: 'Deleted Successfully',
            addSuccessfully: 'Added Successfully',
            reLogin: 'Re-Login',
            senderName: 'Sender Name',
            Search: 'Search',
            exporttoexcel: 'Export To Excel',
            rejectionResson: 'Rejection Reason',
            addNewCITCKeywords: 'Add New Keyword',
            addCITCKeywords: 'Add  Keyword',
            editKeyword: 'Edit Keyword',
            CITCKeywordsList: 'Keywords List',
            CITCKeywords: 'Keywords',
            preApprovedTemplates: 'القوالب المعتمدة مسبقاً',
            addPreApprovedTemplate: 'إضافة قالب معتمد مسبقاً',
            editPreApprovedTemplate: 'تعديل قالب معتمد مسبقاً',
            addPreApprovedTemplateConfirm: 'هل أنت متأكد من إضافة هذا القالب المعتمد مسبقاً؟',
            editPreApprovedTemplateConfirm: 'هل أنت متأكد من تحديث هذا القالب المعتمد مسبقاً؟',
            templateId: 'معرف القالب',
            contentPreview: 'معاينة المحتوى',
            templateContent: 'محتوى القالب',
            editSuccessfully: 'تم التحديث بنجاح',
            saveFailed: 'فشل الحفظ',
            loadFailed: 'فشل تحميل البيانات',
            regulationsMenu: 'لوائح الذكاء الاصطناعي',
            regulationsListTitle: 'إدارة لوائح الذكاء الاصطناعي',
            addNewRegulation: 'إضافة لائحة',
            editRegulation: 'تعديل لائحة',
            regulationFilterCategory: 'تصفية حسب الفئة',
            regulationAllCategories: 'كل الفئات',
            regulationCategory: 'الفئة',
            regulationStatus: 'الحالة',
            regulationPolicies: 'نص السياسات',
            regulationAiPrompt: 'موجه الذكاء الاصطناعي',
            regulationCategorySmsTemplate: 'قالب رسالة نصية',
            regulationCategorySenderName: 'اسم المرسل',
            regulationStatusDraft: 'مسودة',
            regulationStatusActive: 'نشط',
            regulationPoliciesPlaceholder: 'أدخل نص اللائحة المستخدم لتوليد موجه الفحص.',
            regulationPoliciesRequired: 'نص السياسات مطلوب.',
            regulationCannotEditActive: 'لا يمكن تعديل اللوائح النشطة.',
            regulationLoadFailed: 'تعذر تحميل اللوائح.',
            regulationDeleteFailed: 'تعذر حذف اللائحة.',
            regulationSaveFailed: 'تعذر حفظ اللائحة.',
            noActiveRegulationFoundForThisCategory: 'لا توجد لائحة نشطة لهذه الفئة',
            regulationSaved: 'تم الحفظ بنجاح.',
            MessageTemplateDashboard: 'إدارة النماذج',
            templateDescription: 'وصف النموذج',
            templateValue: 'محتوى القالب',
            previewContent: 'معاينة المحتوى',
            autoValidation: 'التحقق التلقائي',
            channel: 'القناة',
            loading: 'جارٍ التحميل...',
            value: 'القيمة',
            suggestedFreeContent: 'محتوى مجاني مقترح',
            suggestedFreeContentDescription: 'اختر نموذجاً مجانياً يتوافق مع التصنيف المحدد. عند الاختيار يتم تعطيل إدخال المحتوى وتخطي التحقق بالذكاء الاصطناعي.',
            selectClassificationForSuggestedContent: 'اختر التصنيف (Classification) أعلاه لعرض النماذج المجانية المقترحة (3 كروت).',
            noSuggestedTemplates: 'لا توجد نماذج مجانية مقترحة متاحة لهذا التصنيف.',
            selectSuggestedFreeTemplate: 'يرجى اختيار نموذج مجاني مقترح',
            deselect: 'إلغاء الاختيار',
            selected: 'محدد',
            speedUpApproval: 'تسريع الموافقة',
            licensesAndApproval: 'التراخيص والموافقة',
            pdfFilesOnly: 'نوع الملف المسموح: PDF فقط.',
            maxLicenseAttachments: 'الحد الأقصى 3 ملفات.',
            uploadLicensesAndApproval: 'رفع التراخيص والموافقة',
            smsTemplateRegulationsLink: 'لوائح نماذج الرسائل النصية (PDF)',
            addVariable: 'إضافة متغير',
            templateVariableBoundaryInvalid: 'يجب ألا يبدأ النموذج أو ينتهي بمتغير. استخدم زر الحذف لإزالة المتغيرات.',
            deleteVariable: 'حذف متغير',
            variableExample: 'مثال للمتغير',
            variableExamplesRequired: 'يجب أن تحتوي جميع حقول أمثلة المتغيرات على قيمة.',
            charactersRemaining: 'الأحرف المتبقية',
            templateCharacterCount: 'عدد الأحرف: {count} (الحد الأدنى: {min})',
            templateDescriptionMinLength: 'يجب أن يكون وصف النموذج 3 أحرف على الأقل',
            templateDescriptionMaxLength: 'يجب ألا يتجاوز وصف النموذج 160 حرفاً',
            aiValidationRemarks: 'ملاحظات التحقق بالذكاء الاصطناعي',
            organizationNameSuffix: 'سيتم إلحاق اسم المنظمة تلقائياً',
            senderNameInformation: 'معلومات اسم المرسل',
            cstTemplateRegulations: 'تنظيمات هيئة الاتصالات لتسجيل نماذج الرسائل',
            senderNameFilter: 'اسم المرسل',
            dataNotFound: 'لم يتم العثور على بيانات',
            senderNameShouldNotBeOneOfTheKeywords: 'Sender Name Could Not Be One Of The Keywords',
            PaymentSuccess: 'تم الدفع بنجاج',
            PaymentFaild: 'حدث خطأ في عملية الدفع',
            PaymentFaildMsg: 'اذا تم اقتطاع المبلغ يرجى مراجعة الآدمن',
            GotoDashboard: 'الرجوع إلى الصفحة الرئيسية',
            senderType: 'Sender Type',
            Rejected: 'Rejected',
            Expired: 'Expired',
            Deleted: 'Deleted',
            Active: 'Active',
            Deactivated: 'Deactivated',
            PendingApproval: 'Pending Approval',
            AddUsersuccessfully: 'Add User Successfully',
            domainHelperTextPrefix: 'Looking for a Saudi domain (.sa)? Check the list of licensed registrars:',
            domainHelperTextLink: 'https://nic.sa/registrars/',
            commercialRegistrationNumber: 'Commercial Registration Number',
            internationalCommercialRegistrationNumber: 'International Commercial Registration Number',
            Approved: 'Approved',
            senderStatus: 'Sender Status',
            customerType: 'Customer Type',
            senders: 'Senders',
            senderNameShouldbenumbersandChar: 'Sender Name Should Contains  Numbers & Characters',
            senderNameShouldbe2OrmoreChar: 'Minimum Length of the sender is 2 characters',
            Report: 'Report',
            Reports: 'Reports',
            ReportsOverview: 'Overview Report',
            approveDateFrom: 'Approve Date From',
            approveDateTo: 'Approve Date To',
            createdDate: 'Created Date',
            createdDateTo: 'Created Date To',
            createdDateFrom: 'Created Date From',
            customerId: 'Customer Id',
            MSISDN: 'MSISDN (SAN)',
            taxNumber: 'Tax Registration Number',
            hasInternational: 'Request International Sender',
            unifiedNumber: 'Unified Number',
            errorUserCertificate: 'Not same user, Please Re-Login the current user',
            deactivateInputText: 'هل أنت متأكد أنك تريد إلغاء تفعيل أسماء المرسل المحددة؟',
            deactivateInputTextSingle: 'هل أنت متأكد أنك تريد إلغاء تفعيل اسم المرسل هذا؟',
            NotAllSenderApprovedOrPaid: 'Not All Selected Senders Approved Or Paid',
            approveInputText: 'Are you sure you want to Approve the selected Senders?',
            approveContractInputText: 'Are you sure you want to approve the selected contract?',
            approveMessageInputText: 'Are you sure you want to approve the selected request?',
            approveProviderRequestInputText: 'Are you sure you want to Approve this Request?',
            approveProviderRequestsBulk: 'هل أنت متأكد أنك تريد قبول طلبات مقدمي الخدمة المحددة؟',
            rejectProviderRequestInputText: 'هل أنت متأكد أنك تريد رفض هذا الطلب؟',
            rejectProviderRequestsBulk: 'هل أنت متأكد أنك تريد رفض طلبات مقدمي الخدمة المحددة؟',
            resendInputText: 'Are you sure you want to Resend the selected Senders?',
            resendMessageTemplateInputText: 'Are you sure you want to Resend the selected Message Template Requests?',
            editProviderInputText: 'Are you sure you want to Edit Provider?',
            updateProviderInputText: 'Are you sure you want to update provider info?',
            editKeywordInputText: 'Are you sure you want to Edit Keyword?',
            addKeywordInputText: 'Are you sure you want to Add Keyword?',
            editUserInputText: 'Are you sure you want to Edit User?',
            addUserInputText: 'Are you sure you want to Add User?',
            confirmRoleChange: 'Confirm Role Change',
            cstRoleChangeText: 'Are you sure you want to switch {fromRole} Role to {toRole}?',
            CSTAdmin: 'CST Admin',
            CSTUser: 'CST User',
            addInput: 'Add',
            addShortCodeInputText: 'Are you sure you want to Add Short Code?',
            editShortCodeInputText: 'Are you sure you want to Edit Short Code?',
            addsubmitRequestInputText: 'Are you sure you want to Add Request?',
            editSenderInputText: 'Are you sure you want to Edit Sender ?',
            editInput: 'Edit',
            updateInput: 'Update',
            userCertificate: 'User Certificate',
            advertisement: 'Advertisement',
            service: 'Service',
            awareness: 'Awareness',
            warning: 'Warning',
            language: 'English',
            dashboard: 'Sender Request Dashboard',
            providers: 'Providers',
            operators: 'Operators',
            errorSenderNameDuplicate: 'This sender name already exists in your list',
            SenderNameExist: 'Sender name already exist',
            selectSenderType: 'Select sender type first',
            selectStatus: 'Select Status',
            shorts: 'Shorts',
            userManagement: 'User Management',
            rowsPerPage: 'Rows Per Page',
            newUser: 'New user',
            editUser: 'Edit user',
            name: 'Name',
            userName: 'User Name',
            userEmail: 'User Email',
            phoneNumber: 'Phone Number',
            phoneNumberAdmin: 'Provider Admin Phone Number',
            userNameAdmin: 'Provider Admin User Name',
            userEmailAdmin: 'Provider Admin User Email',
            country: 'Country ',
            city: 'City',
            district: 'District',
            streetName: 'Street Name',
            buildingNumber: 'Building Number',
            postalCode: 'Postal Code',
            vATNumber: 'VAT Number',
            additionalNumber: 'Additional Number',
            otherIdentifier: 'Other ID',
            type: 'Type',
            selectOperator: 'Select Operator',
            selectProvider: 'Select Provider',
            selectType: 'Select Type',
            save: 'Save',
            userInfo: 'User information',
            providerName: 'Provider Name',
            operatorName: 'Operator Name',
            editInfo: 'Edit Info',
            actions: 'Actions',
            deleteInput: 'Delete',
            deactivateInput: 'Deactivate',
            resendInput: 'Resend',
            approveInput: 'Approve',
            deleteInputText: 'Are you sure you want to delete the selected items?',
            cancel: 'Cancel',
            delete: 'Delete',
            addProvider: 'Add Provider',
            editProvider: 'Edit Provider',
            add: 'Add',
            clientName: 'Client Name',
            crNumber: 'CR Number',
            budgetNumber: 'Budget Number',
            representativeName: 'Representative Name',
            enterpriseUnifiedNumber: 'Enterprise Unified Number',
            startDate: 'Start date',
            durationYear: 'Duration ( Year)',
            representativeEmail: 'Representative Email',
            representativePhoneNumber: 'رقم جوال المفوض',
            attachDelegationLetter: 'Attach Delegation Letter',
            attacDocument: 'Attach Document',
            attachRegistrationDocument: 'Attach Registration Document',
            attachUnifiedNumberDocument: 'Attach Unified Number Document',
            attachbudgetNumberDocument: 'Attach Budget Number Document',
            attachlicenseNumberDocument: 'Attach HRSD License Number Document',
            attachcommercialRegistrationNumberDocument: 'Attach Commercial Registration Number Document',
            attachinternationalCommercialRegistrationNumberDocument: 'Attach International Commercial Registration Number Document',
            additionalAttachments: 'Additional Attachments',
            isAlreadyExist: 'I attest that the sender has been already activated before launching the system. As a result the sender will not be sent to operators for activation',
            optional: '(Optional)',
            AlreadyActivated: 'هل اسم المرسل و الرموز القصيرة مفعلة في أنظمة قواعد بيانات المشغلين قبل إطلاق هذه المنصة الإلكترونية؟',
            attach: 'Attach',
            SenderConnectivitySupport: 'Sender Connectivity Support',
            SupportPaymentTransaction: 'Payment Transaction',
            paymentReference: 'Payment Reference',
            sendersList: 'Sender Type',
            reset: 'Reset',
            next: 'Next',
            back: 'Back',
            stcShortCodes: 'STC ShortCodes',
            mobileAccounts: 'Mobile Accounts',
            zainShortCodes: 'Zain ShortCodes',
            salamShortCodes: 'Salam ShortCodes',
            addToList: 'Add to list',
            zainSC: 'Zain SC',
            mobilySC: 'Mobily SC',
            stcSC: 'STC SC',
            salamSC: 'Salam SC',
            apEmail: 'AP Email',
            sendersShortCodesList: 'Senders/ShortCodes List',
            duration: 'Duration',
            senderValidityPeriodExceeds5Years: 'The sender validity period cannot exceed 5 years',
            year: 'Year',
            submit: 'Submit',
            requestSubmittedSuccessfully: 'Request submitted successfully',
            newRequest: 'New request',
            requestsListPage: 'Requests list page',
            editRequest: 'Edit Request',
            changeSenderType: 'Change Sender Type',
            changeSenderTypeInput: 'Change Sender Type',
            changeSenderTypeInputText: 'Are you sure you want to Change Sender Type?',
            request: 'Request',
            edit: 'Edit',
            actionHere: 'Action here',
            payment: 'Payment',
            cardNumber: 'Card number',
            exDate: 'Ex. Date',
            nameCard: 'Name on the card',
            orderSummary: 'Order Summary',
            CreditLimit: 'Credit Limit',
            CreditCard: 'Credit Card',
            paidSuccessfully: 'Paid Successfully',
            PaymentOptions: 'Payment Options',
            subtotal: 'Subtotal',
            total: 'Total',
            paymentInformation: 'Payment information',
            payNaw: 'Pay Now',
            payLater: 'الدفع لاحقاً',
            renewalPaymentBack: 'رجوع',
            senderRenewalRequestAddedSuccessfully: 'تم إضافة طلب تجديد اسم المرسل بنجاح',
            senderRenewalRequestCreatedPendingPayment: 'تم إنشاء طلب تجديد اسم المرسل بنجاح. الحالة: بانتظار الدفع. يرجى إكمال عملية الدفع.',
            senderRenewalRequestPaymentCompletedStatusUpdated: 'تمت عملية الدفع بنجاح. تم تحديث حالة طلب تجديد اسم المرسل إلى تم الدفع.',
            senderRenewalRequestPaymentFailedStillPending: 'فشلت عملية الدفع. تم إنشاء طلب التجديد. تابع إلى طلبات تمديد المدة لإكمال الدفع',
            privacy: 'Privacy',
            termsOfUse: 'Terms of use',
            copyRight: 'All rights is reserved for T2 © MSG Stack',
            deleteShortSuccessfully: 'Delete Short Code is successfully',
            addShortSuccessfully: 'Add Short Code is successfully',
            updateShortSuccessfully: 'Update Short Code is successfully',
            addConectivitySuccessfully: 'Add Connectivity is successfully',
            emailVerification: 'التحقق من البريد الإلكتروني',
            otpSentToEmail: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني. يرجى إدخال الرمز لإرسال طلبك.',
            enterVerificationCode: 'أدخل رمز التحقق',
            otpExpiredMessage: 'انتهت صلاحية رمز التحقق. يرجى طلب رمز جديد.',
            otpResendCountDown: 'إعادة الإرسال متاحة بعد',
            verificationSuccessful: 'تم التحقق بنجاح. تم إرسال طلبك.',
            invalidOTPCode: 'رمز التحقق غير صحيح. يرجى المحاولة مرة أخرى.',
            otpResentSuccessfully: 'تم إعادة إرسال رمز التحقق إلى بريدك الإلكتروني.',
            verify: 'تحقق',
            errorOccurred: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
            forbiddenCharsError: 'الرموز <، > و -- غير مسموح بها.',
            resendtooperator: 'Resend To Operator',
            resentSuccessfully: 'Resent To Operator Successfully',
            addProviderSuccessfully: 'Add Provider is successfully',
            editProviderSuccessfully: 'Edit Provider is successfully',
            updatedProviderSuccessfully: 'Updated Provider successfully',
            Ok: 'Ok',
            noSenderNames: 'No Sender Names',
            select: 'Select',
            noData: 'No Data',
            noDataAvailable: 'لا توجد بيانات',
            logOut: 'Logout',
            logOutText: 'Are you sure you want to Logout?',
            yes: 'نعم',
            no: 'No',
            Go: 'Go',
            rejectionReason: 'Rejection Reason',
            paymentDateFrom: 'Payment Date From',
            paymentDateTo: 'Payment Date To',
            clientInfo: 'Client Info',
            contractInfo: 'Contract Info',
            reviewRequest: 'Review Request',
            connectingSenderName: 'Connecting Sender Name',
            connectingRequestDashboard: 'Contract Request Dashboard',
            check: 'check',
            aiValidation: 'التحقق باستخدام AI',
            loadingAIValidation: 'جاري التحقق بالذكاء الاصطناعي. يرجى الانتظار..',
            classification: 'التصنيف',
            Advertising: 'إعلان',
            Service: 'خدمة',
            Warning: 'تحذير',
            Verification: 'موثوقية',
            Awareness: 'توعية',
            aiCheckFailed: 'ظهر مشكلة أثناء التحقق بالذكاء الاصطناعي. راجع التفاصيل بالأسفل.',
            representativeIDNumber: 'Representative Id Number',
            verificationType: 'Verification Type',
            automatic: 'Automatic Verification',
        },
        rejectionReason: {
            addNewReason: 'Add New Reason',
            requestType: 'Request Type',
            rejectionText: 'Rejection Reason',
            rejectionReasonList: 'Rejection Reason List',
            editRejectionReasonSuccessfully: 'Edit Rejection Reason Successfully',
            addRejectionReasonSuccessfully: 'Add Rejection Reason Successfully',
            deleteRejectionReasonSuccessfully: 'Delete Rejection Reason Successfully'
        },
        senderComplaints: {
            notAllSenderAreDeactivated: 'Not All Sender Are Deactivated',
            complaintId: 'Complaint Id',
            reactivate: 'Reactivate',
            providerName: 'Provider Name',
            provider: 'Provider',
            createdDate: 'Created Date',
            requestDate: 'Request Date',
            reactivatedsuccessfully: 'Reactivated Successfully',
            deactivate: 'Deactivate',
            deactivated: 'Deactivated',
            requests: 'Requests',
            senders: 'Senders',
            activated: 'Activated',
            senderNameSearch: 'Sender name',
            status: 'Status',
            of: 'of',
            daysLeft: 'days left',
            senderName: 'Sender Name',
            newRequest: 'New request',
            clientName: 'Client Name',
            details: 'Details',
            groupedSenderComplaints: 'Complaints details',
            transactionCommunicationNumber: 'TCN',
            tcnNumber: 'رقم TCN',
            groupedTableSenderName: 'اسم المرسل',
            groupedTableSenderType: 'نوع اسم المرسل',
            complaintDate: 'تاريخ البلاغ',
        },
        loginPage: {
            requestsAlertsPendingActivation: 'Requests Alerts - Pending Activation',
            requestsAlertsPendingPaymentRequests: 'Requests Alerts - Pending Payment Requests',
            requestsAlertsPendingApprovalRequests: 'Requests Alerts - Pending Approval Requests',
            cstTaguser: 'Users With CST Tag Name Type Can Not Login',
            serviceuser: 'Users With Service Type Can Not Login',
            aPIUser330: 'Users With 330API User Type Can Not Login',
            logoTextMain: 'MSG Stack',
            logoTextSub: 'SMS Management system',
            loginHeader: 'Login to my account',
            loginNote1: 'Please, use your account credential to login to the platform',
            enterOtp: 'Please, please Enter Otp to login to the platform',
            OtpReminingTime: 'OTP Will be expired after',
            resendOtp: 'Resend OTP',
            verfiy: 'Verfiy',
            verfiyOTP: 'Verfiy OTP',
            userName: 'User Name',
            password: 'Password',
            canNotLogin: 'I can’t login to my account',
            login: 'Login',
            restoreMyPassword: 'Restore my password',
            restoreNote1: 'We will reset the password for your account by sending a verification code to your email through this process.',
            restoreNote2: 'Do want to proceed?',
            backToLoginForm: 'Back to login form',
            yesUnderstand: 'Yes, I understand',
            pleaseInsertEmail: 'Please, insert your email',
            email: 'Email',
            sendVerificationCode: 'Send verification code',
            verificationNote1: 'Verification code has been send to your email',
            verificationNote2: 'Please, insert the verification code',
            resendCodeAgain: 'Resend Code again',
            verify: 'Verify',
            setPasswordNote1: 'Verification code verified',
            setPasswordNote2: 'Please, insert your new password',
            setNewPassword: 'Set new password',
            captchaRequired: 'Please complete the security verification and try again.',
            passwordResetedSuccessfully: 'Password reseted successfully',
            backToLogin: 'Back to login',
            updateShortCodeType: 'تم تحديث الشورت كود واضافة نوع له، يرجى الاطلاع والتعديل عليه من خلال الصفحة الخاصة به',


        },
        dashboardPage: {
            contractFind: 'Display Contracts',
            contractDateBy: 'Contract Date By',
            finalApprove: 'Final Approve',
            review: 'review',
            NotAllSenderCanBeRejected: 'Not All Selected Senders Can Be Rejected',
            someContractsAreMergeInserted: 'Some Contracts Are Merge Inserted',
            senderExpiryDate: 'Sender Expiry',
            expiryDate: 'Expiry Date',
            comment: 'Comment',
            active: 'Active',
            requestId: 'Request Id',
            all: 'All',
            edit: 'Edit',
            providerName: 'Provider Name',
            provider: 'Provider',
            createdDate: 'Created Date',
            requestDate: 'Request Date',
            approved: 'Approved',
            paid: 'Paid',
            deactivate: 'Deactivate',
            requests: 'Requests',
            senders: 'Senders',
            thisMonth: 'This month',
            partially: 'Partially',
            activated: 'Activated',
            inactive: 'Inactive',
            pendingFor: 'Pending for',
            payment: 'Payment',
            approval: 'Approval',
            rejected: 'Rejected',
            senderNameSearch: 'Sender name, ID search',
            NotAllSenderActivateOrPartiallyActivated: 'Not All selected Senders are Activate Or Partially Activated',
            representativeName: 'Representative Name',
            representativeMobile: 'Representative Mobile',
            representativeEmail: 'Representative Email',
            deactivatedsuccessfully: 'Deactivated Successfully',
            status: 'Status',
            of: 'of',
            daysLeft: 'days left',
            renew: 'Renew',
            pause: 'Pause',
            sendRemainder: 'Send remainder',
            terminate: 'Terminate',
            senderName: 'Sender Name',
            newRequest: 'New Request',
            clientName: 'Client Name',
            operatorStatus: 'Operator Status',
            details: 'Details',
            Approve: 'Approve',
            reject: 'Reject',
            Pay: 'Pay',
            NotAllSenderPendingApproval: 'Not All Selected Senders Are Pending for Approval',
            NotAllRequestsPendingApproval: 'Not All Selected Requests Are Pending for Approval',
            Approvedsuccessfully: 'Senders Has been Approved successfully',
            RequestApprovedsuccessfully: 'Requests Has been Approved successfully',
            Rejectedsuccessfully: 'Senders Has been Rejected successfully',
            RequestRejectedsuccessfully: 'Request Has been Rejected successfully',
            NotAllSenderRequestRelatedToThisTenant: 'Not All Sender Requests Related To This Tenant',
            NotAllSenderPendingPay: 'Not All Selected Senders Are Pending for Pay',
            Paysuccessfully: 'Paid successfully',
            rejectreason: 'Reject Reason',
            resend: 'Resend',
            exportToExcel: 'Export All Senders To Excel',
            exportRequestsToExcel: 'Export All Requests To Excel',
            NotAllSenderRejected: 'Not All Selected Sender status Rejected',
            NotAllTemplateRejected: 'حالة جميع النماذج المحددة يجب أن تكون مرفوضة',
            resentSuccessfully: 'Resent Successfully',
            checkSender: 'Check',
            checkAvailability: 'التحقق من الإتاحة',
            senderNotFound: 'اسم المرسل غير موجود',
            NotAllRequestsCanBeDeleted: 'لا يمكن حذف جميع الطلبات المحددة',
            NotAllRequestsCanBeDeactivated: 'لا يمكن إلغاء تفعيل جميع الطلبات المحددة',
            RequestDeletedSuccessfully: 'تم حذف الطلب بنجاح',
            RequestDeactivatedsuccessfully: 'تم إلغاء تفعيل الطلب بنجاح',
        },
        userManagementPage: {
            users: 'Users',
            providerName: 'Provider Name',
            OperatorName: 'Operator Name',
            UserPassword: 'User Password',
            AddUserSuccessfully: 'User Added successfully',
            EditUserSuccessfully: 'User Edited  successfully',
            export: 'تصدير',
            exportSuccess: 'تم تصدير التقرير بنجاح',
            exportFailed: 'تعذر تصدير التقرير',
        },
        extendDurationRequestsPage: {
            renew: 'Renew',
            extendRequestId: 'Extend Request Id',
            extendDuration: 'Extend Duration',
            pay: 'Pay',
            senderName: 'Sender Name',
            requestDate: 'Request Date',
            status: 'Status',
            actions: 'Actions',
            extendDurationRequests: 'Extend Duration Requests',
            requests: 'Requests',
        },
        updateDataRequestsPage: {
            requestId: 'رقم الطلب',
            senderName: 'اسم المرسل',
            clientName: 'اسم الجهة',
            updateType: 'نوع التحديث',
            representativeName: 'اسم المفوض',
            requestDate: 'تاريخ الطلب',
            status: 'الحالة',
            requests: 'الطلبات',
            entityData: 'بيانات الجهة',
            entityName: 'اسم الجهة',
            clientData: 'بيانات الجهة',
            comparison: 'الحقول المتغيرة',
            fieldName: 'اسم الحقل',
            currentInformation: 'المعلومات الحالية',
            requestedInformation: 'المعلومات المطلوبة',
            updateRequestDetails: 'تفاصيل طلب التحديث',
            reviewChangesSubtitle: 'راجع التغييرات المطلوبة من قبل مزود الخدمة.',
            currentInformationBefore: 'المعلومات الحالية (قبل التحديث)',
            requestedInformationAfter: 'المعلومات المطلوبة (بعد التحديث)',
            commentsOptional: 'التعليقات (اختياري)',
            addCommentsPlaceholder: 'أضف تعليقاتك هنا...',
            providerComment: 'تعليق مقدم الخدمة',
            approvalComment: 'تعليق الموافقة',
            nothingChanged: 'لم يتم إجراء أي تغييرات',
            approveConfirm: 'هل أنت متأكد أنك تريد الموافقة على الطلب المحدد؟',
            rejectConfirm: 'هل أنت متأكد أنك تريد رفض الطلب المحدد؟',
            representativeDataUpdate: 'تحديث بيانات المفوض',
        },
        providerPage: {
            providersList: 'Providers list',
            addNewProvider: 'Add new provider',
            providerSearch: 'Provider name, ID search',
            addingDate: 'Adding Date',
        },
        senderInfo: {
            comment: 'Comment',
            requestStatus: 'Request Status',
            status: 'الحالة',
            createdDate: 'Date',
            dateTime: 'التاريخ والوقت',
            processedBy: 'تمت المعالجة بواسطة',
            system: 'النظام',
            dueToComplaint: 'بسبب شكوى',
            manualDeactivation: 'إلغاء تفعيل يدوي',
            manualDeletion: 'حذف يدوي',
            noActivityHistory: 'لا يوجد سجل نشاط لهذا الاسم المرسل.',
            rejectionReason: 'Rejection Reason',
            extendRequestId: 'Extend Request Id',
            duration: 'Duration'
        },
        scamPage: {
            scamList: "Scam List",
            newScamList: "New Scam List",
            senderName: 'Sender Name',
            clientName: 'Client Name',
            scamId: 'ScamId'
        },
        shortPage: {
            shortCodeList: 'Short code list',
            addNewShortCode: 'Add new short code',
            company: 'Company',
            shortCode: 'Short code',
            addShortCode: 'Add short code',
            editShortCode: 'Edit short code',
            companyName: 'Company Name',
            selectCompany: 'Select company',
            operatorSearch: 'Operator name, ID search',
            shortcodeSearch: 'short Code name, ID search',
            whiteList: 'القائمة البيضاء',
            blackList: 'القائمة السوداء',
            providerName: 'اسم مقدم الخدمة',
            remaningDays: 'Sender Expiring in',
            contractExpiryDate: 'Contract Expiry in',
            confirmDisconnect: 'تأكيد رمز فصل الشورت كود',
            otpMessage: 'لتأكيد فصل الشورت كود عن أسماء المرسلين، أدخل رمز التحقق المرسل إلى بريدك.',
            disconnectedSuccessfully: 'تم فصل أسماء المرسلين بنجاح.',
            confirmDeleteShortCode: 'تأكيد حذف الرمز القصير',
            deleteOtpMessage: 'لتأكيد حذف الرمز القصير المحدد، أدخل رمز التحقق المكوّن من 6 أرقام المرسل إلى بريدك. يمكن إعادة الإرسال بعد انتهاء العد التنازلي (5 دقائق).',
            deleteShortCodeSuccess: 'تم حذف الرمز القصير بنجاح.',
            otpRemainingTimeLabel: 'الوقت المتبقي',
            resendOtpButton: 'إعادة إرسال الرمز',
            verifyOtpButton: 'تحقق من الرمز',
            confirmDisconnectTitle: 'فصل الشورت كود',
            confirmDisconnectMessage: 'هل أنت متأكد من أنك تريد فصل الشورت كود المحدد؟',
            shortCodeNumbersOnly: 'يجب أن يحتوي الرمز القصير على أرقام فقط',
        },
        employeeStatistics: {
            allProcessingRequests: 'All Processing Requests',
            finalApprovedProcessingRequests: 'Final Approved Processing Requests',
            approvedProcessingRequests: 'Approved Processing Requests',
            rejectedProcessingRequests: 'Rejected Processing Requests',
            requests: 'Requests',
            exportToExcel: 'Export To Excel',
            requestId: 'Request Id',
            senderName: 'Sender Name',
            processingBy: 'Processing By',
            processingDateFrom: 'Processing Date From',
            processingDateTo: 'Processing Date To',
            processingDate: 'Processing Date',
            processingResult: 'Processing Result',
            requestType: 'Request Type'
        },
        monitorDashboard: {
            requests: 'Requests',
            notifications330: '330 Notifications',
            requestsDashboard: 'Requests Dashboard',
            notifications330Dashboard: '330 Notifications Dashboard',
            allComplaints: 'إجمالي البلاغات',
            pendingComplaints: 'البلاغات تحت المعالجة',
            resolvedComplaints: 'البلاغات المعالجة',
            complaintsProcessingAverage: 'متوسط معالجة البلاغات',
            notifications: 'Notifications',
            overview: 'Overview',
            senderNames: 'Sender Names',
            createdDate: 'Created Date',
            from: 'From',
            to: 'To',
            requestType: 'Request Type',
            requestStatus: 'حالة الطلب',
            customerType: 'Customer Type',
            smsServiceProvider: 'SMS Service Provider',
            serviceProvider: 'Service Provider',
            all: 'All',
            senderRequest: 'Sender Request',
            contractRequest: 'Contract Request',
            government: 'Government',
            private: 'Private',
            charity: 'Charity',
            requestsWithinSla: 'Requests within SLA',
            requestsExceededSla: 'Requests Exceeded SLA',
            approvalProcessingAverage: 'Approval Processing Average',
            paymentProcessingAverage: 'Payment Processing Average',
            activationProcessingAverage: 'Activation Processing Average',
            processingWithin2BusinessDays: 'Processing within 2 business days',
            processedIn3OrMoreBusinessDays: 'Processed in 3 or more business days',
            daysSuffix: 'days',
            allRequests: 'All Requests',
            allRequestsDetailsTitle: 'تفاصيل جميع الطلبات',
            allRequestsDetailsEmpty: 'لا توجد طلبات تطابق عوامل التصفية الحالية.',
            requestTimelineDetailsTitle: 'تفاصيل الجدول الزمني للطلبات',
            requestTimelineDetailsEmpty: 'لا توجد طلبات تطابق عوامل التصفية الحالية.',
            delayedRequestsDetailsTitle: 'تفاصيل الطلبات المتأخرة',
            delayedRequestsDetailsEmpty: 'لا توجد طلبات متأخرة تطابق عوامل التصفية الحالية.',
            delayedDays: 'أيام التأخير',
            requestTimelineByCustomerTypeDetailsTitle: 'تفاصيل الجدول الزمني للطلبات حسب نوع العميل',
            requestTimelineByCustomerTypeDetailsEmpty: 'لا توجد طلبات تطابق عوامل التصفية الحالية.',
            exportToExcel: 'تصدير إلى Excel',
            requestId: 'Request Id',
            senderName: 'Sender Name',
            senderType: 'Sender Type',
            clientName: 'Client Name',
            senderExpiryDate: 'Sender Expiry Date',
            forever: 'Forever',
            requestTypeNewSender: 'New Sender',
            requestTypeUseSender: 'Use Sender',
            requestTypeNewContract: 'New Contract',
            requestTypeRenewContract: 'Renew Contract',
            requestTypeContract: 'Contract',
            requestTimeline: 'Request Timeline',
            requestTimelineByCustomerType: 'Requests Timeline by Customer Type',
            total: 'Total',
            pendingApproval: 'Pending Approval',
            approved: 'Approved',
            rejected: 'Rejected',
            paid: 'Paid',
            expired: 'Expired',
            deleted: 'Deleted',
            deactivated: 'Deactivated',
            customerTypeLabel: 'Customer type',
            requestsCountLabel: 'Requests',
            senderNameLengthCompliance: 'Sender Name Length Compliance',
            compliance: 'Compliance',
            sendersByNodes: 'Senders By Nodes',
            sendersDuration: 'Senders Duration',
            sendersExpirationTimeline: 'Sender Expiration Timeline',
            senderExpirationLegend: 'Sender',
            sendersRenewalTimeline: 'Senders Renewal Timeline',
            activeSendersTimeline: 'Active Senders Timeline',
            activeSendersTimelineDetailsTitle: 'Active Senders Timeline Details',
            activeSendersTimelineDetailsEmpty: 'No active senders match the current filters.',
            senderExpirationTimelineDetailsTitle: 'Sender Expiration Timeline Details',
            senderExpirationTimelineDetailsEmpty: 'No senders match the current filters.',
            senderRenewalTimelineDetailsTitle: 'Sender Renewal Timeline Details',
            senderRenewalTimelineDetailsEmpty: 'No renewal requests match the current filters.',
            sendersDurationDetailsTitle: 'Sender Duration Details',
            sendersDurationDetailsEmpty: 'No senders match the current filters.',
            sendersByNodesDetailsTitle: 'Senders by Nodes Details',
            sendersByNodesDetailsEmpty: 'No senders match the current filters.',
            senderNameLengthComplianceDetailsTitle: 'Sender Name Length Compliance Details',
            senderNameLengthComplianceDetailsEmpty: 'No senders match the current filters.',
            senderNameLengthColumn: 'Sender Name Length',
            isCompliant: 'Is Compliant',
            senderNameDuration: 'Sender Name Duration',
            renewalDuration: 'Renewal Duration',
            requestsBySmsProviderAndSenderType: 'Requests by SMS Service Provider and Sender Type',
            requestsBySmsProviderAndSenderTypeDetailsTitle: 'Requests by SMS Service Provider and Sender Type Details',
            requestsBySmsProviderAndSenderTypeDetailsEmpty: 'No senders match the current filters.',
            sendersRenewalYAxis: 'Number of sender renewal requests',
            sendersRenewalTooltipCount: 'Sender renewal requests',
            activeSendersTooltipCount: 'Active senders',
            sendersExpiringAxisLabel: 'Number of sender names expiring',
            years: 'Years',
            loading: 'Loading...',
            noDataAvailable: 'No data available',
            delayedRequests: 'Delayed Requests',
            noDelayedRequestsAvailable: 'No delayed requests available',
            invalidDateRange: 'Start date must be on or before end date.',
            retryLoad: 'Retry',
            emptyChartTitle: 'Nothing to display for these filters',
            emptyChartHintFilters: 'Widen the created date range or set SMS provider, service provider, and customer type to All, then click Apply.',
            emptyChartHintReset: 'You can also use Reset to restore the default date range (from launch to today).',
            emptyTimelineTitle: 'No monthly request volume in this range',
            emptyChartHintDateRange: 'Try extending the start date toward 2022-02-01 or the end date toward today.',
            emptyStackedTimelineTitle: 'No requests by customer type in this period',
            emptyChartHintCustomerType: 'If Customer Type is not All, clear it to see the full mix.',
            scrollWideChartHint: 'This chart scrolls horizontally — use the scrollbar or swipe to see all periods.',
            emptyDelayedTitle: 'No delayed requests for this view',
            emptyDelayedHint: 'Either there are no delayed items, or filters exclude every provider row.',
            emptySendersTitle: 'No sender duration data',
            emptySendersDurationHint: 'Confirm paid senders exist in the period; duration uses the latest paid request per sender.',
            emptySendersByNodesTitle: 'No senders by node',
            emptySendersByNodesHint: 'Paid senders are counted per node; try All tenants or a broader date range.',
            emptyComplianceTitle: 'No compliance breakdown',
            emptyComplianceHint: 'Compliance is computed from active senders in range — expand dates or clear tenant filters.',
            emptyProviderSenderTitle: 'No provider and sender-type mix',
            emptyProviderSenderHint: 'Include more providers by clearing the SMS filter or widening dates.',
            emptyRenewalTimelineTitle: 'No renewal activity in this window',
            emptyRenewalTimelineHint: 'Renewals appear when matching requests exist; broaden the created date range.',
            emptyExpirationTimelineTitle: 'No expirations in the forward window',
            emptyExpirationTimelineHint: 'Expiration buckets are forward-looking; adjust filters if the range is very narrow.',
            emptyActiveSendersTimelineHint: 'Active senders follow lifecycle windows; broaden created-date filters to include more requests.',
            noRequestsDataFor: 'No Available Requests for {chartName} chart',
            noRequests: 'No Available Requests',
            noSenderssDataFor: 'No Available Senders for {chartName} Chart',
            noMonitorDashboardChartDataFor: 'لا توجد بيانات للمخطط: {chartName}.',
            complaintsStatuses: 'حالات البلاغات',
            complaintsStatusesDetailsTitle: 'تفاصيل حالات البلاغات',
            complaintsStatusesTooltipCount: 'عدد البلاغات',
            complaintFrequencyPerSender: 'تكرار البلاغات لكل اسم مرسل',
            complaintFrequencyPerSenderDetailsTitle: 'تفاصيل تكرار البلاغات لكل اسم مرسل',
            complaintFrequency: 'تكرار البلاغات',
            complaintFrequencyTooltipSenderName: 'اسم المرسل',
            complaintFrequencyTooltipComplaintStatus: 'حالة البلاغ',
            complaintStatus: 'حالة البلاغ',
            complaintsTimeline: 'الجدول الزمني للبلاغات',
            complaintsTimelineDetailsTitle: 'تفاصيل الجدول الزمني للبلاغات',
            complaintsTimelineDetailsEmpty: 'لا توجد بلاغات تطابق الفلاتر الحالية.',
            complaintsTimelineTooltipReceived: 'البلاغات المستلمة',
            complaintsCountLabel: 'البلاغات',
            statusPendingForReview: 'قيد المراجعة',
            statusDeactivated: 'تم التعطيل',
            statusFalseComplaint: 'بلاغ خاطئ',
            statusReactivated: 'تمت إعادة التفعيل',
            emptyComplaintsStatusesTitle: 'لا توجد بيانات',
            emptyComplaintsStatusesHint: 'لا توجد بلاغات في الفترة المحددة. عدّل نطاق التاريخ أو الفلاتر ثم انقر تطبيق.',
            emptyComplaintsTimelineTitle: 'لا توجد بيانات',
            emptyComplaintsTimelineHint: 'لا توجد بلاغات في الفترة المحددة. عدّل نطاق التاريخ أو الفلاتر ثم انقر تطبيق.',
            emptyComplaintFrequencyTitle: 'لا توجد بيانات',
            emptyComplaintFrequencyHint: 'لا توجد بلاغات لأي اسم مرسل في الفترة المحددة. عدّل الفلاتر ثم انقر تطبيق.',
        },
    },
};

const i18n = new VueI18n({
    locale: 'en',
    messages,
});

export default i18n;
